'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true,
});
exports.workshops =
    exports.PAYMENT =
    exports.PARENTS =
    exports.PERMISSIONS =
    exports.PERSONAL =
    exports.TUTOR =
    exports.REGISTER_SUCCESS =
    exports.register =
    exports.symbol =
    exports.vision =
    exports.activity =
    exports.educational =
    exports.contact =
    exports.footer =
    exports.signup =
    exports.about =
    exports.branches =
    exports.donate =
    exports.event =
    exports.thanks =
    exports.reports =
    exports.press =
    exports.mainpage =
    exports.navbar =
    exports.LANGUAGE =
        void 0;
const branch_parser_1 = require('./tools/branch_parser');
const cities_1 = require('./tools/cities');
const countries_1 = require('./tools/countries');
const moment = require('moment');
exports.LANGUAGE = 'hebrew';
//////////Navbar/////////
let YEARS_ARR = [];
let num = 0;
let year = moment('1997-01-01').format('YYYY');
for (var i = 100; i >= 0; i--) {
    let elem = moment(year).add(num, 'years').format('YYYY');
    if (elem < moment().format('YYYY') + 1) {
        YEARS_ARR.push(elem);
        num++;
    }
}
let DAYS_ARR = [];
for (var i = 1; i <= 31; i++) {
    DAYS_ARR.push(i);
}
exports.navbar = {
    NAVHOME: 'דף הבית',
    NAV1: 'אודות',
    NAV2: 'סניפים',
    NAV3: 'דו"חות',
    NAV4: 'מהתקשורת',
    NAV5: 'מרכז ידע',
    NAV6: 'הלב - פורטל פעילים',
    NAV7: 'צור קשר',
    NAV8: 'הרצאות וסדנאות',
    NAV_SIGN: 'הרשמה',
    NAV_DONATE: 'לתרומה',
    educational_title: 'התפיסה החינוכית',
    educational_text: 'יוצרים יחד מקום ומשמעות לכל אדם',
    activity_title: 'פעילות התנועה',
    activity_text:
        'ייחודן של פעילויות התנועה נובע מהתאמתן לאנשים עם מוגבלויות.',
    vision_title: 'חזון וערכי התנועה',
    vision_text:
        'חיבור שיתוף בין צעירים עם מוגבלויות, לבין צעירים ללא מוגבלויות.',
    view_btn: 'צפה בעמוד',
    symbol_tite: 'טקסים וסמלים',
    symbol_text: 'סמל החזון שלנו',
    go_back: 'חזרה לעמוד הבית',
    navbar_h2: 'כנפיים של קרמבו',
    navbar_h4: 'תנועת נוער לצעירים עם ובלי צרכים מיוחדים',
    aboutSub1: 'הערכים שלנו',
    aboutSub2: 'אודות התנועה',
    aboutSub3: 'מבנה התנועה',
    aboutSub4: 'ציוני דרך',
    aboutSub5: 'חברי ההנהלה',
    aboutSub6: 'ועד מנהל',
    aboutSub7: 'חזון התנועה',
    aboutSub8: 'דברי המנכלית',
    pressSub1: 'פרויקטים ושיתופי פעולה',
    pressSub2: 'מן העיתונות',
    pressSub3: 'מגזין קרמבו',
    homeSub1: 'המפעלים שלנו',
    homeSub2: 'הערכים שלנו',
    homeSub22: 'חזון וערכי התנועה',
    homeSub3: 'שותפינו ותומכינו',
    homeSub4: 'פרסים והוקרה',
};
//////////Main Page Text//////////
exports.mainpage = {
    //BANNER//
    ART_H3: 'תערוכת אומנות',
    ART_H2: 'של בנק הפועלים',
    ART_H2_2: 'למען כנפיים של קרמבו',
    ART_H2_2_DOT: '.',
    ART_H1: '21.12.19',
    BANNER_H1: 'יובל שר יוסי ',
    BANNER_H2: 'למען ילדי ‘כנפיים של קרמבו’',
    BANNER_P: '*מופע טרום הבכורה',
    BANNER_BTN: 'תקנון הגרלת "חלום כפול"',
    BANNER_ULAM: 'אולם סיטי הול',
    BANNER_MIKUM: 'סינמה סיטי גלילות',
    BANNER_STARTSHOW: 'תחילת המופע',
    BANNER_STARTSHOW_TIME: '21:00',
    BANNER_STARTSHOW_DATE: '26.5.2019',
    CATALOG_BTN: 'לקטלוג לחצו כאן',
    MAIN_S1_H2: 'מחנה קיץ',
    MAIN_S1_H3: 'מחנה קיץ, המותאם גם לילדים ובני נוער עם צרכים מיוחדים',
    MAIN_S2_H2: 'הקמת סניפים',
    MAIN_S2_H3: 'סניף חדש שנפתח מביא שמחה ותחושת סיפוק לעשרות פעילים',
    MAIN_S3_H2: 'הכשרה והדרכה',
    MAIN_S3_H3: 'מערך ההכשרה וההדרכה שלנו, המכשיר את כלל בעלי התפקידים',
    MAIN_S4_H2: 'חניכים',
    MAIN_S4_H3: 'עלויות הקליטה לחניך בעל צרכים מיוחדים ומה הן כוללות',
    MAIN_S5_H2: 'מסע לפולין',
    MAIN_S5_H3: 'מסע משלחת הנוער המשותפת אל עבר אתרי הזיכרון בפולין',
    MAIN_S6_H2: 'שנת שירות',
    MAIN_S6_H3: 'קומונות השירות של "כנפיים של קרמבו" ועלותן המשוערת',
    MAIN_S1_READ: 'המשך קריאה',
    MAIN_DONATE_CHANGE: 'המחויבות שלנו',
    MAIN_DONATE_CHANGE_TEXT1: 'מחויבות',
    MAIN_DONATE_CHANGE_TEXT2: 'מחויבות ליצירת מקום',
    MAIN_DONATE_CHANGE_TEXT3: 'מחויבות לקיום פעילות',
    MAIN_DONATE_CHANGE_TEXT4: 'מחויבות להובלת',
    MAIN_DONATE_CHANGE_TEXT11: 'להנגשה מלאה',
    MAIN_DONATE_CHANGE_TEXT22: 'ומשמעות לכל אדם',
    MAIN_DONATE_CHANGE_TEXT33: 'חברתית חינוכית',
    MAIN_DONATE_CHANGE_TEXT44: 'שינוי חברתי',
    STORIES_H1: 'סיפורים בטעם קרמבו',
    STORY1_TITLE: 'חרם',
    STORY1_NAME: 'סיפורה של ליז בישלה',
    STORY1_TEXT:
        'הסיפור של ליז בישלה על היותה “השעיר לעזאזל” של הכיתה, כיצד התמודדה עם חוויית החרם ומה למדה מהחוויה. ליז מספרת על תחושת השייכות שקיבלה ב”כנפיים של קרמבו”.',
    STORY2_TITLE: 'מייקאובר',
    STORY2_NAME: 'סיפורה של מיכל כהן',
    STORY2_TEXT:
        'מיכל כהן מספרת על תקופת ההתבגרות המאתגרת שחוותה ועל הקשיים הרבים איתה התמודדה, וכיצד הצטרפות לתנועת “כנפיים של קרמבו” שינתה את השקפת עולמה',
    STORY3_TITLE: '“אהבה ממבט ראשון”',
    STORY3_NAME: 'הסיפור של גדי דקל',
    STORY3_TEXT:
        'סיפורו המרתק של גדי דקל על דייטים הראשונים והמפתעים שנכח בהם. גדי מספר כיצד התאהב ברוח התנועה ובתוצר הסופי שלה - חיוכים ואושר אצל כל הצדדים המעורבים.',
    STORY4_TITLE: 'קדושים',
    STORY4_NAME: ' הסיפור של ענבל אילסר',
    STORY4_TEXT:
        'ענבל אילסר מספרת על חייה בקומונה המשולבת הראשונה בישראל, ומדוע היא חשה מוזר כשהקופאי בסופר מודיע לה שהיא עושה "עבודת קודש".',
    STORY5_TITLE: 'אאוטסיידר',
    STORY5_NAME: 'הסיפור של אמיל אויפמן',
    STORY5_TEXT:
        'הסיפור של אמיל אויפמן מספר על הבדידות שחווה בילדותו, תחושת אי השייכות, החומות שבנה והבחירה האמיצה שעשה על מנת להתגבר.',
    STORY6_TITLE: 'תיק',
    STORY6_NAME: 'הסיפור של שלו גולדנברג ',
    STORY6_TEXT:
        'הסיפור של שלו גולדנברג על התמודדות עם התיק הרגשי הכבד שהכביד עליו במשך תקופה ארוכה בחייו, ועל שותפיו למסע שבהם נעזר על מנת להקל על המעמסה.',
    STORY7_TITLE: ' האחיות',
    STORY7_NAME: 'הסיפור של האחיות ליאה ורני  ',
    STORY7_TEXT:
        'ליאה ורני קמחי מספרות על הקשר המיוחד השורר ביניהן והחוויות הראשונות שלהן מתנועת "כנפיים של קרמבו". לימים הפכה ליאה לרכזת בסניף "צור יגאל" ורני לחניכה משולהבת.',
    STORY8_TITLE: 'להיות שונה',
    STORY8_NAME: 'הסיפור של קסם בר',
    STORY8_TEXT:
        'הסיפור של קסם בר, על כיצד גילתה את השוני בחייה, כיצד חששה ממנו בילדותה ואיך לאחר שהצטרפה למשפחת כנפיים של קרמבו, גילתה שלהיות שונה זה בכלל לא בושה.',
    STORY_LINK: 'ערוץ היוטיוב שלנו',
    PARTNERS: 'שותפינו ותומכינו',
    DONATE: 'לתרומה',
    FULL_LIST: 'לרשימה המלאה',
    AWARDS_H1: 'פרסים והוקרה',
    AWARD1: '"אות תמרי"- (כיום "אות רמון")- על איכות, מנהיגות ומצוינות',
    AWARD2: '"אות ברנשטיין"-  ע"ש סילביה ברנשטיין ז"ל- על התנדבות ומנהיגות חברתית',
    AWARD3: 'יקירת העיר הוד השרון "ליונס ישראל"- לעדי אלטשולר מייסדת התנועה',
    AWARD4: 'עשרת יזמי השנה -"ארנסט אנד יאנג" בשיתוף "דה מרקר"- לעדי אלטשולר מייסדת התנועה',
    AWARD5: ' "הדלקת משואה ביום העצמאות ה-60 למדינת ישראל" - בשם תנועות הנוער ובני הנוער המתנדבים',
    AWARD6: '"אות הנשיא למתנדב"- על עשיה למען שינוי חברתי של בני הנוער הפעילים ב´כנפיים של קרמבו´',
    AWARD7: 'התנועה החברתית של העשור-עיתון "מעריב"',
    AWARD8: 'תו מידות לאפקטיביות ניתן לתנועה בעקביות מדי שנתיים',
    AWARD9: 'פרס משרד החינוך מחוז דרום  לחיים  באומוול , חבר ועד מנהל של התנועה',
    AWARD10: 'פרס יגאל אלון למעשה מופת חלוצי',
    NEW_BRANCH_H1: 'הקמת סניפים',
    NEW_BRANCH_1_H2: 'כל סניף חדש שנפתח מביא שמחה לעשרות פעילים',
    NEW_BRANCH_1_P:
        'רבים מאתנו היו בתנועות נוער או חווים את הפעילות המיוחדת הזאת דרך הילדים הפרטיים שלנו, ויודעים עד כמה חשובים חיי חברה להתפתחות תקינה של ילדים.´כנפיים של קרמבו´ הינה תנועת נוער לילדים ונוער עם צרכים מיוחדים, המשלבת אותם בפעילות חברתית-חינוכית עם בני נוער מהחינוך הכללי',
    NEW_BRANCH_1_P_2:
        'ילדים עם צרכים מיוחדים מורכבים, מתקשים לפתח חיי חברה בגלל אתגרים כגון מגבלות תקשורת, צורך במקום נגיש עבורם והיותם ´שונים´.אתגרים אלו מקשים עליהם ולפעמים מונעים מהם להיפגש עם בני גילם, עם ובלי צרכים מיוחדים, ולהצטרף לתנועות הנוער הפועלות בישראל.',
    NEW_BRANCH_2_H2: ' קצת על מה שקורה בפעילות הסניפים',
    NEW_BRANCH_2_P:
        ' הפעילות בסניפים מתקיימת מידי שבוע, בשעות אחר הצהריים, במשך כשלוש שעות, במודל של חונכות אישית-במסגרת קבוצתית. לכל חניך מוצמדים שני חונכים המתווכים עבורו את הפעילויות, לומדים להכירו ומלווים אותו לאורך כל השנה.',
    NEW_BRANCH_2_P_2:
        ' החניכים והחונכים עושים יחדיו למען הקהילה: מתנדבים יחדיו, פעילים במוסדות הדמוקרטים של התנועה, עוברים פעולות ואפילו נופשים יחד במחנה קיץ.',
    NEW_BRANCH_3_H2: ' קצת על מה שקורה בפעילות הסניפים',
    NEW_BRANCH_3_P:
        ' התנועה רואה בפתיחת סניפים חדשים ביישובי הארץ, ציווי מוסרי ופועלת להקמת סניף בכל עיר בישראל. בסניף פעילים עד 40 ילדים בעלי צרכים מיוחדים וכ-100 בני נוער החונכים אותם.',
    NEW_BRANCH_3_P_2:
        ' הסניפים אשר נפתחים בפריפריה הפיזית והחברתית בישראל, הם פרי שיתוף פעולה של התנועה עם הרשויות המקומיות, אשר מקצות את המקום הנגיש לפעילות ומסייעות במימון הסעת החניכים בעלי הצרכים המיוחדים, מביתם לסניף ובחזרה.',
    NEW_BRANCH_3_P_3:
        ' התנועה פועלת לגיוס שותפים מהארץ ומחו"ל לשם הקמת סניפי תנועה חדשים.אנו מאמינים באיגום כוחות של קהילת העסקים המקומית והארצית, של קרנות פילנטרופיות ושל תורמים פרטיים – למען הקמת הסניפים.',
    NEW_BRANCH_STICKER:
        'תנועת ´כנפיים של קרמבו´ נתפחה במיוחד עבור ילדים בעלי צרכים מיוחדים. היא מותאמת לצרכיהם ונגישה עבורם. ',
    krembo_wings: '‘כנפיים של קרמבו’',
    our_sections: 'המפעלים שלנו',
    SUMMER_CAMP_H1: 'מחנה קיץ ',
    SUMMER_CAMP_H2:
        'מחנה קיץ חוויתי, המותאם גם לילדים ובני נוער עם צרכים מיוחדים',
    SUMMER_CAMP_H3:
        "כמו כל תנועות הנוער, גם תנועת 'כנפיים של קרמבו' מקיימת מחנה קיץ חווייתי לחניכיה. המחנה מותאם לכל החניכים, גם לחניכים עם צרכים מיוחדים.",
    SUMMER_CAMP1_H3: 'מחנה קיץ שהוא גם חופשה משפחתית',
    SUMMER_CAMP1_P:
        'במחנה הקיץ נהנים ומשתתפים, גם בני המשפחות של חניכים עם צרכים מיוחדים אנו רואים חשיבות רבה בשילוב בני המשפחות במחנה הקיץ, מתוך אמונה כי למשפחה תפקיד חשוב בהעצמת ילדים החיים עם צרכים מיוחדים מורכבים.',
    SUMMER_CAMP1_P2:
        'בנוסף, הורים לילדים עם צרכים מיוחדים מתמודדים מדי יום עם טיפול אינטנסיבי בצרכיו של ילדם ומתקשים לעמוד בהוצאות חופשה משפחתית שהופכת למורכבת יותר, הן מבחינה ארגונית והן מבחינה כלכלית. מחנה הקיץ של כנפיים של קרמבו מעניק למשפחות גיבוש משפחתי, מנוחה וחוויה משותפת.',
    SUMMER_CAMP2_H3: 'מתי מתקיים מחנה הקיץ ומה קורה בו',
    SUMMER_CAMP2_P:
        'המחנה מתקיים מידי שנה בחודש אוגוסט, בבית קיי בנהריה - אתר הנופש היחיד בישראל שבו כמות חדרים רבה הנגישה לכיסאות גלגלים. לאור הדרישה הרבה של המשפחות, מחנה הקיץ מתקיים בשלושה מחזורים.',
    SUMMER_CAMP2_P2:
        'הפעילויות במחנה מותאמות לכל המשתתפים באופן מודולרי, המשלב אותם יחד ולחוד בפעילויות נופש חווייתיות ומאתגרות: פעילות בבריכה, פעולות יצירה, ספורט, יוגה, תחרויות, הצגות, מופעים, קוסמים, קבוצות תמיכה למשתתפים ופעולות שמטרתן גיבוש חווייתי, הן של החניכים עם חונכיהם והן שלהם עם בני משפחתם. החונכים, אשר מבלים זמן ארוך ואיכותי עם חניכיהם, זוכים להכירם בצורה עמוקה יותר, מכירים את בני המשפחה הסובבים אותם ומאפשרים להורים זמן איכות לעצמם ולילדיהם האחרים.',
    SUMMER_CAMP_BTN: 'איך מצטרפים',
    SUMMER_CAMP_LEFT:
        '“מעולם לא חווינו נופש משפחתי משותף. הייתה זו החוויה הכי מגבשת ומהנה לה זכינו מאז נולד הבן המיוחד שלנו, לפני 15 שנים!”',
    TRAINIGN_H1: 'הכשרה והדרכה',
    TRAINIGN_H2: 'הכשרת חונכים וצוותים',
    TRAINING_P_1:
        '´כנפיים של קרמבו´ היא תנועת הנוער הראשונה והיחידה לילדים ובני נוער בעלי צרכים מיוחדים מורכבים. התנועה משלבת חניכים עם צרכים מיוחדים בפעילות חינוכית חברתית, יחד עם בני נוער מהחינוך הכללי ונוער בסיכון בגילאי 18-14, המשמשים חונכים ומתווכי פעילות עבורם.',
    TRAINING_P_2:
        'החניכים בעלי הצרכים המיוחדים הינם ילדים ונוער, בגילאי 21-7.ילדים אלו אינם מתקבלים לתנועות הנוער האחרות, מפאת נכותם הקשה ולרבים מהם הבדידות אף קשה יותר מהנכות.',
    TRAINING_P_3:
        ' לרבים מהחניכים בעלי הצרכים המיוחדים, זוהי הפעילות החברתית היחידה לה הם זוכים מחוץ למסגרת בית הספר וההזדמנות היחידה לקשרים חברתיים עם ילדים ובני נוער החיים ללא מגבלות.',
    TRAINING_H3:
        'עבור מרבית החונכים, זהו המפגש הראשון עם בני גילם, החיים עם צרכים מיוחדים.',
    TRAINING_P_4:
        'לשם הכשרתם וכדי להבטיח את תפקודם המיטבי עבור חניכים בעלי צרכים מיוחדים,נדרש מערך הדרכה נרחב ועמוק.',
    TRAINING_P_5:
        ' מערך ההכשרה והדרכה של התנועה מיועד לכל בעלי התפקידים חונכים, צוות מוביל, רכזים ובוגרים המלווים את הסניפים ורכזי צרכים מיוחדים. ',
    TRAINING_P_6:
        'פיתוח ההכשרה וההדרכה בתנועה משפר את התושייה התפקודית, רמת הביצוע, המקצועיות ותחושת המחויבות לתנועה מצד החונכים ובעלי התפקידים בסניפים.',
    TRAINING_JOIN: 'איך מצטרפים',
    TRAINING_MILESTONES_H2: 'יעדי ההכשרה',
    TRAINING_MILESTONES_P_1:
        'מתן כלים מקצועיים לחונכים, לשם התמודדות עם ילדים בעלי צרכים מיוחדים ולתקשורת מיטבית עימם (כולל שפת הסימנים).',
    TRAINING_MILESTONES_P_2:
        'שיפור היכולות והמיומנויות של החונכים ובעלי התפקידים בסניפים בתחומים כגון הדרכה, כישורים חברתיים ותקשורתיים, עבודת צוות.',
    TRAINING_MILESTONES_P_3:
        'יצירת שיח חונכים ארצי, מפרה ומצמיח וגיבוש תנועתי.',
    TRAINING_MILESTONES_P_4:
        'מתן כלים מקצועיים לניהול הסניפים, התנהלות לוגיסטית ולהנעת מתנדבים',
    TRAINING_MILESTONES_P_5:
        'פיתוח מנהיגות צעירה של בני נוער כמובילי שינוי בסביבתם החברתית ובקהילה.    ',
    TRAINING_MILESTONES_P_6:
        'יצירת מערך פעילויות של הסניפים בקהילה, שמטרתו הובלת שינוי חברתי.',
    TRAINING_MILESTONES_2_H2: 'קורסים וסמינרים',
    TRAINING_MILESTONES2_P1: 'הכשרת חונכים בסניפים.',
    TRAINING_MILESTONES2_P2:
        'סמינר פתיחת שנה, אמצע וסוף שנה (מחוזי/ארצי) - לחונכים ולבעלי תפקידים.',
    TRAINING_MILESTONES2_P3:
        'סמינר מודולרי (מחוזי/ארצי) לבעלי תפקידים: צוותים מובילים, רכזים בוגרים ורכזי צרכים מיוחדים.',
    TRAINING_MILESTONES2_P4: 'סמינר הדרכה (מחוזי/ארצי) לצוותי ההדרכה.',
    TRAINING_MILESTONES2_P5: 'הכשרה חודשית (ארצי) לרכזי צרכים מיוחדים.',
    TRAINING_MILESTONES2_P6: 'יום חונכים תנועתי ארצי.',
    POLAND_H1: 'מסע לפולין',
    POLAND_H2: 'מסע משלחת נוער מיוחדת לאתרי הזיכרון בפולין',
    POLAND_P1:
        "בשנת 2013, בני הנוער הפעילים ב'כנפיים של קרמבו' יזמו את הקמתה של משלחת נוער משותפת של חניכים וחונכים, למסע לאתרי הזיכרון בפולין. היוזמה הגיעה מתוך תחושה שלכולם מגיע האפשרות והזכות לייצג את מדינת ישראל במדי התנועה.",
    POLAND_P2:
        'כתנועה, אנו מאמינים כי המסע לפולין הוא מסע עוצמתי של אדם לשורשיו ולעצמו ובזכות חיבוקה של הקבוצה הוא אף עוצמתי יותר. למסע המיוחד שלנו משמעות חברתית נרחבת, בחיבור בין אוכלוסיות ויצירת קהילה תומכת ומגובשת.',
    POLAND_P3:
        'משלחת הנוער שלנו מונה 90 אנשים וכוללת: בני נוער עם ובלי צרכים מיוחדים, הורים מלווים של החניכים ו-10 אנשי צוות מטה התנועה ומדריכים. ההכנה למסעה של המשלחת המיוחדת היא עמוקה וכוללת את כל התכנים ההיסטוריים ומשמעותם העמוקה וכן הכנה רגשית המותאמת לחניכים והחונכים כאחד.',
    POLAND_H3: 'כל חברי המשלחת, כולל הורי החניכים, שותפים בכל מרכיבי ההכנה',
    POLAND_P4:
        'סדנאות, מפגשים, הצגה וביקורים ב׳יד ושם׳ / קיבוץ לוחמי הגטאות. חלק מהחונכים והחניכים היוצאים למסע, הם בני משפחות קשות יום אשר מצבן הכלכלי אינו מאפשר מימון חלקם בעלות הנסיעה ואנו מגייסים מימון עבורם.',
    SERVICE_H1: 'שנת שירות',
    SERVICE_H2: 'קומונת שנת שירות',
    SERVICE_P:
        'משנת 2016 אנו פועלים ב-5 קומונות: בנוף הגליל, יפו, הוד השרון, קרית גת ובאר שבע. בכל קומונה פועלים 10-8 בני נוער בשנת שרות. תכנית הפעילות של הקומונות נבנית יחד עם הרשות המקומית במרחבן הן פועלות.',
    SERVICE_P2:
        'בשעות הבוקר, פעילי שנת השירות עוסקים בתחומי שילוב ילדים עם צרכים מיוחדים בבתי הספר במסגרת החינוך הפורמלי ובשעות אחר הצהריים עוסקים בפעילויות חברתיות במסגרת החינוך הבלתי פורמלי, עם נוער בסיכון ונוער מנותק. בנוסף, פעילי שנת השירות מעניקים סיוע, תמיכה והדרכה לסניפים במחוז בו הם פועלים.    ',
    SERVICE_H3:
        'עלות משוערת לתפעול הקומונה עומדת על כ-150,000 ש"ח לשנת פעילות.',
    PARTICIPANTS_H1: 'חניכים',
    PARTICIPANTS_H2: 'עלות קליטת חניך בעל צרכים מיוחדים',
    PARTICIPANTS_P:
        'על מנת לקלוט חניך עם צרכים מיוחדים לפעילות, אנו נדרשים למערך תמיכה נרחב. עלות קליטת חניך בעל צרכים מיוחדים לפעילות שוטפת בתנועה, ',
    PARTICIPANTS_H3: 'מסתכמת בכ-4,500 ₪ לשנה.',
    PARTICIPANTS_P2_SMALL: 'העלות כוללת את כל מרכיבי הפעילות השוטפת בסניפים',
    PARTICIPANTS_P2:
        'אמצעי התקשורת הייחודיים הנדרשים עבור שילוב מיטבי של חניכים בפעילות, יצירת פעולות נגישות, חומרי יצירה, מפעלים תנועתיים (כמו מחנה קיץ), טיולים סניפיים, סדנאות, מופעים, ציון חגים וימי הולדת, ועוד.',
    PARTICIPANTS_H2_2: 'ביטוחים',
    PARTICIPANTS_P3:
        'העלות המשוערת של ביטוח כלל פעילי התנועה בסניפים מגיעה לסכום של כ-30 ש"ח בשנה לכל פעיל. העלות המשוערת ל5,000 פעילי התנועה הקיימים היא כ- 150,000 שקלים',
    PARTICIPANTS_H2_3: 'מדי התנועה',
    PARTICIPANTS_P4:
        'כל פעילי התנועה לובשים את אותם המדים, כסימן לשוויון ואחדות מדי התנועה הם חולצה בצבע תכלת עם סמל התנועה ועניבה חומה. החולצה עוצבה כך שתהיה נגישה לילדים עם מוגבלויות פיזיות והיא קלה ללבישה. החולצה והעניבה נרכשות בתחילת שנת הפעילות ע "י כל פעיל במחיר של 50₪ . עלות ל-5,000 פעילי התנועה היא 250,000₪',
    PARTICIPANTS_H2_4: 'הסעות',
    PARTICIPANTS_P5:
        'התנועה מנגישה את פעולותיה גם באמצעות הפעלת מערך הסעות נגישות. אנו מסיעים את החניכים מבית הוריהם לפעילות הסניף ובחזרה. עלות ההסעה השנתית תלויה במיקום הסניף (סניף מקומי או אזורי) ונעה בין 35,000 ₪ לסניף מקומי ועד 100,000 ₪ לסניף אזורי עלות משוערת: בין 35,000 ₪ ל-100,000',
    PARTICIPANTS_btn: 'הרשמת חניך',
    special: 'בהוקרה מיוחדת',
    sliderHebrew: true,
    langString: 'he',
    TOP_PAGE_H2: 'תנועת נוער לצעירים עם ובלי צרכים מיוחדים',
    TOP_PAGE_NUTTON_DONATE: 'לתרומה',
    TOP_PAGE_NUTTON_SIGNUP: 'הרשמה',
    TOP_PAGE_NUMBERS_RIGHT_H2: 'פעילים',
    TOP_PAGE_NUMBERS_LEFT_H2: 'סניפים',
    TOP_PAGE_NUMBERS_RIGHT_H3: 'בתנועת הנוער “כנפיים של קרמבו”',
    TOP_PAGE_NUMBERS_LEFT_H3: 'בפריסה ארצית ועוד מספר רב בתהליך הקמה',
    BIG_VIDEO_H1: 'איל קיציס עושה כנפיים לקרמבו',
    VIDEO_SECTION_P1:
        'דמיינו את עולמכם בלי חברים, האם בכלל אפשרי לדמיין עולם כזה? זאת המציאות שאליה מתעוררים אלפי ילדים כבר כמה שנים!',
    VIDEO_SECTION_H2:
        "'כנפיים של קרמבו' יוצאת בקמפיין גיוס תרומות באמצעות אפליקציית",
    VIDEO_SECTION_PAYBOX: 'PayBox',
    VIDEO_SECTION_P2:
        'למימון פתיחת סניפים עבור כ- 3000 ילדים עם צרכים מיוחדים ומורכבים שנמצאים ברשימות המתנה כדי להצטרף לפעילות חברתית נגישה ומותאמת.',
    MAIN_PAGE_HEADING_PART_1: `כ-3,000 ילדים בעלי צרכים מיוחדים מחכים להצטרף`,
    MAIN_PAGE_HEADING_PART_2: `לכנפיים של קרמבו`,
    values_h1: 'הערכים שלנו',
    value1_h3: 'הובלת שינוי חברתי',
    value1_p:
        "כנפיים של קרמבו' היא תנועת נוער לצעירים עם ובלי צרכים מיוחדים. כן, אנחנו תנועת נוער לכל דבר ופעילי התנועה לא רואים בפעילותם 'עשייה התנדבותית' , אלא עשייה חברתית וחווייתית - למען עצמם ולמען אחרים.",
    value2_h3: 'קיום פעילות חברתית חינוכי',
    value2_p:
        "פעילות חברתית-חינוכית, בלתי פורמאלית, פעם בשבוע בשעות אחה'צ, במודל של חונכות אישית-במסגרת קבוצתית. מרבית החונכים הינם בני נוער מהחינוך הכללי. הפעילות המשותפת תורמת להגברת המודעות לאוכלוסיות מיוחדות ולנגישות חברתית.",
    value3_h3: 'יוצרים מקום ומשמעות לכל אדם',
    value3_p:
        'אנו פועלים מתוך אמונה כי לכל הילדים-ללא הבדלי יכולת, מוצא, דת או מגדר, יש צורך משותף: כל הילדים רוצים וצריכים להרגיש שייכות חברתית ולכל ילד מגיע ליהנות בין חברים.',
    value4_h3: 'מחויבות להנגשה מלאה',
    value4_p:
        "מקום פעילות נגיש, הסעת חניכים מביתם למקום הפעילות וחזרה, בהסעות המותאמות לנכים, ההסעה מפוקחת ומלווה ע'י פעיל של התנועה, בכל פעולה. מטפלת סיעודית, המסייעת בצרכים האינטימיים של הפעילים, במהלך הפעילות, בכל אחד מסניפי התנועה.",
    vision_header: 'חזון וערכי התנועה',
    create_h2: 'יוצרים יחד מקום ומשמעות לכל אדם',
    create1_h3: 'החזון משקף את רוחה של התנועה ואת הקוד האתי שלה',
    create1_p:
        'יצירה משותפת של מקום משמעותי, תורם ובעל השפעה עבור כל אחד מהפעילים, בין אם הוא בעל צרכים מיוחדים ובין אם לא.',
    create2_h3:
        'את פעילות בתנועה מובילים בני נוער, עם ובלי מוגבלויות, המגיעים מרקע חברתי ותרבותי מגוון',
    create2_p:
        'פעילי התנועה הם דור העתיד שיעצב את דמותה של החברה הישראלית, ברוח ערכי השוויון החברתי, תוך דאגה ומחשבה על רווחת כלל האוכלוסיות המרכיבות את החברה הישראלית.',
    create3_h3: 'המשימה הניצבת בפני התנועה: להקים סניף בכל יישוב וקהילה בישראל',
    create3_p:
        'על מנת לאפשר שוויון הזדמנויות חברתי, חיי חברה ושייכות חברתית לכל ילד עם צרכים מיוחדים - ללא הבדלי תרבות, מצב סוציואקונומי, דת ומגדר. בנוסף, לשנות תפיסות ועמדות כלפי אנשים בעלי מוגבלויות, בן של צעירים בני אותו גיל והן של החברה הישראלית כולה.',
    circle1_h3: 'אני חבר - ערבות הדדית',
    circle1_p:
        'לדאוג האחד לשני. לקבל את העובדה שאף אחד מאיתנו אינו מושלם. לכבד כל אחד ואת יכולותיו. לעזור, לתמוך לקבל ולתווך.',
    circle2_h3: 'אני אוהב - "ואהבת לרעך כמוך" ',
    circle2_p:
        ' אהבה מתוך ההבנה והיכולת לקבל כל מצב באהבה, גם מצבים קשים. לראות את החיובי ולפעול מתוך שמחה.',
    circle3_h3: 'אני ישראלי',
    circle3_p:
        'כנפיים של קרמבו הוקמה בישראל, מתוך האופי הישראלי המאופיין בשותפות ועזרה לזולת. בכנפיים של קרמבו חברים בני נוער מגווניה השונים של הקשת החברתית בישראל. אנו מובילים את החברה הישראלית לשינוי עמדות ותפיסות כלפי מוגבלות.',
    circle4_h3: 'אני שייך - שייכות, הכלה, הדדיות',
    circle4_p:
        'כל אחד מממש את הפוטנציאל שלו ושותף תורם בעשייה. תפקידנו לאפשר ולעזור לכל אחד לממש את הפוטנציאל שלו. עלינו לדעת לעזור ולהיעזר.',
    circle5_h3: 'אני יכול - יכולת ועצמאות',
    circle5_p:
        'האמונה שלי בעצמי, ביכולת שלי להשפיע ולשנות וברצון שלי לבחור ולהיות עצמאי.',
    circle6_h3: 'אני מוביל - מחויבות, אחריות, מנהיגות',
    circle6_p:
        'כל אחד מאיתנו מנהיג ומקדם את העשייה. כל אחד מאיתנו יכול להוביל לשינוי וכולנו יחד מנהיגים שינוי חברתי.',
};
//////////From Press page////////////
exports.press = {
    PRESS_H1: 'מן התקשורת',
    PRESS_SIGAL_BTN: 'צור קשר',
    PRESS_HEADER_NAME: 'סיגל דקל',
    PRESS_HEADER_POSITION: 'מנהלת יחסי ציבור',
    PRESS_HEADER_TEXT_1:
        'שמשה במהלך עשר שנים כבעלים משותף ומנהלת יחסי הציבור וקשרי הלקוחות של קבוצת מיתוס (חברת שיווק והפקות אירועים שיווקיים מהמובילות בישראל).',
    PRESS_HEADER_TEXT_2:
        'בעברה שימשה בתפקידי יחסי ציבור ודוברות בארגונים ומשרדים מובילים כארד תקשורת, שיאון תקשורת ופרסום שירה שקולניק.',
    PRESS_HEADER_TEXT_3:
        'בעלת תואר ראשון ולימודי תקשורת מאוניברסיטת תל אביב, מנהלת את תחום יחסי הציבור בכנפיים של קרמבו החל מינואר 2014.',
    PRESS_HEADER_CONTACT: 'צור קשר',
    PROJECTS_H1: 'פרויקטים קרמבואיים ושיתופי פעולה',
    PROJECT1_TITLE: 'סיפור הסניפים דוברי הערבית',
    PROJECT1_TEXT:
        'סיפור פועלם של סניפי "כנפיים של קרמבו" בחברה הערבית, כיצד תורמים לאיחוד הקהילות וחשיבות שילובם בכלל האוכלוסיות בישראל',
    PROJECT2_TITLE: 'אומרים תודה לאיקאה',
    PROJECT2_TEXT:
        'ילדי "כנפיים של קרמבו" מודים לאיקאה על כך שהחברה מאמצת אותם כבר תקופה ארוכה, ובזכותה ניתן להמשיך ולהקים סניפים נוספים',
    PROJECT3_TITLE: 'קליפ המנון',
    PROJECT3_TEXT:
        'המנון תנועת "כנפיים של קרמבו", המשקף את חזון ורוח התנועה. נכתב על ידי נועם חורב ובוצע ע"י ביסאן אבו לבן ושי המבר, ביחד עם חניכי התנועה',
    PROJECT4_TITLE: ' מחנה קיץ מהאגדות - אוגוסט 2015 ',
    PROJECT4_TEXT:
        'מחנה הקיץ של "כנפיים של קרמבו" מעניק ימים של שמחה לפעילים המשתתפים בו ותורם לאחדות הרבה שקיימת בקהילה הקרמבואית',
    PROJECT5_TITLE: ' במסע מיוחד לפולין',
    PROJECT5_TEXT:
        'כתבה ששודרה בערוץ הראשון על מסע פעילי "כנפיים של קרמבו" לפולין. פעילי התנועה לא וויתרו ויצאו למסע כשאר בני גילם - מסע של חיים, בארץ ספוגת מוות',
    PROJECT6_TITLE: 'השיר "שווים" בשפת הסימנים',
    PROJECT6_TEXT:
        'שירם של עילי בוטנר ורן דנקר מבוצע כולו בשפת הסימנים על ידי חונכי "כנפיים של קרמבו" מסניף כוכב יאיר - צור יגאל',
    PROJECT7_TITLE: 'כבוד של אלופים',
    PROJECT7_TEXT:
        'בעזרת כנפיים של קרמבו ובשיתוף פעולה של מנהלת הליגות לכדורגל, זכה יואל סביר בן ה-21 להבקיע את שער הנצחון לשוער הפועל באר שבע בזמן שקהל האוהדים מריע לו ארוכות',
    PROJECT8_TITLE: 'פותחים סניף חדש עם עמוס תמם',
    PROJECT8_TEXT:
        'קמפיין גיוס המונים למען פתיחת סניף "כנפיים של קרמבו" בהשתתפות עמוס תמם. תוך כחודש גוייס סכום של כ-200,000₪',
    PROJECT9_TITLE: 'יום חונכים ארצי',
    PROJECT9_TEXT:
        'הזמר רותם כהן, בשירו "אל העולם שלך", בביצוע מרגש בשפת הסימנים, ביחד עם אלפי פעילי התנועה',
    PAPER_H1: 'מן העיתונות',
    PAPER1_TITLE: 'מסדר הכנפיים של הגברת הראשונה.',
    PAPER1_TEXT:
        'עמודי אמצע - נחמה רבלין, הגברת הראשונה מספרת בהתרגשות על אירועי “מסדר כנפיים” של סניף ירושלים בו השתתפה.',
    PAPER2_TITLE: 'הפנים היפות של ישראל: כנפיים של קרמבו מגיעה לאו”ם.',
    PAPER2_TEXT:
        " ​(היום הבינלאומי לשוויון זכויות לאנשים עם מוגבלויות​) על מאי אופיר, החניכה הראשונה בקרמבו ועל הנאום שנשאה באו'ם, במסגרת משלחת מיוחדת של 'כנפיים של קרמבו' ​שהוזמנה לשאת את בשורת...",
    PAPER3_TITLE: '"בשביל בתי זאת הפסגה של הקיץ”.',
    PAPER3_TEXT:
        '(לקראת אירוע ההתרמה) מיכל פעילן על "מחנה הקיץ" של קרמבו ועל אירוח השר בנט במהלכו. "בלי קרמבו כנראה שלא יכולתי לחיות" – מיכל חניכה עם שיתוק מוחין מיבנה.',
    PAPER4_TITLE: 'מנצחים ביחד',
    PAPER4_TEXT:
        "כתבת שער במוסף 'שישבת' על קומונת תל אביב של 'כנפיים של קרמבו', הקומונה המשולבת הראשונה בישראל.",
    PAPER5_TITLE: 'מישהו לעוף איתו',
    PAPER5_TEXT:
        '(לקראת אירוע ההתרמה) חגית רון רבינוביץ על אפיק סופיר - חונך מקריית גת עם עיוורון ושיתוק מוחין ועל החניכה שלו רותם שנמצאת על הרצף האוטיסטי.',
    PAPER6_TITLE: 'משפחה עם כנפיים',
    PAPER6_TEXT:
        '(לקראת אירוע ההתרמה) חגית רון רבינוביץ על יהודית טוויטו מצפת - אם אומנה לעשרות ילדים ובניהם אבירם חניך בקרמבו שהפך למדריך לילד על הרצף האוטיסטי.',
    PAPER7_TITLE: 'מתקשר רק באמצעות מבע פניו - ומאושר.',
    PAPER7_TEXT:
        '(לקראת אירוע ההתרמה) אמלי עמרוסי על תמרה, עולה מדרום אפריקה, אם חד הורית מיבנה, ועל בנה כניה חניך בקרמבו עם שיתוק מוחין שמתקשר רק באמצעות מבע פניו.',
    PAPER8_TITLE:
        'הצעירה שלימדה את המגזר הערבי והבדואי לעזור לילדים עם מוגבלויות',
    PAPER8_TEXT:
        '(יום האישה הבינלאומי) הצעירה שלימדה את המגזר הערבי הבדואי - חיתאם אבו-בדר, מייסדת ומנהלת המחוז הרב תרבותי בקרמבו, פתחה סניפים…',
    PAPER9_TITLE: '"מגיעים לי חברה, אהבה, צחוק ומשמעות”.',
    PAPER9_TEXT:
        '(כתבת פרומו לקמפיין בהדסטארט עם עמוס תמם, לטובת גיוס תרומות להקמת סניף קרמבו ברמלה) פז סולטנוביץ, בת ה- 15, חונכת עם שיתוק מוחין בסניף קריית אונו "קרמבו שינו לי את החיים"',
    PAPER10_TITLE: 'הכניסיני תחת כנפך: הנשים מאחורי התנועה "כנפיים של קרמבו”.',
    PAPER10_TEXT:
        '"הנשים מאחורי תנועת הנוער "כנפיים של קרמבו"- לרגל יום האישה הבינלאומי',
    PAPER11_TITLE: 'לנצח דרקונים.',
    PAPER11_TEXT:
        '(ראש השנה) "לנצח דרקונים" ביקור פעילי קרמבו בגן לילדי מהגרים בדרום תל אביב. ככה מנצחים דעות קדומות ומקרבים לבבות.',
    PAPER12_TITLE:
        'כל הדרך לאו"ם: "כנפיים של קרמבו עושה מהפכה חברתית שקטה, אבל עצומה”.',
    PAPER12_TEXT:
        '"תנועת הנוער המקומית כנפיים של קרמבו רשמה הישג חסר תקדים עם בחירתה ליועצת לארגון ECOSOC של האו"ם בתחום השילוב וההכלה."',
    PAPER13_TITLE:
        "התאומים טומי ויאן ברצ'נקו במהדורת חדשות מרכזית ערוץ 10 'שווים' עם מאיה איידן.",
    PAPER13_TEXT:
        '(היום הבינלאומי לזכויות לאנשים עם צרכים מיוחדים) "שווים" - מאיה איידן עם התאומים טומי ויאן מקרמבו (מדקה 0:53 - בקטעים עד סוף הכתבה)',
    PAPER14_TITLE: 'פורשים כנפיים',
    PAPER14_TEXT:
        '(ערב יום השואה) כתבה על משלחת קרמבו למסע זיכרון מיוחד ונגיש לפולין.',
    PAPER15_TITLE: '15 שנים להיווסדות התנועה',
    PAPER16_TITLE: 'גוליבר וקרמבו נפגשים',
    PAPER17_TITLE: 'כנפיים של קרמבו ושל אפל',
    PAPER18_TITLE: 'ניר ברונשטיין באו"ם',
    PAPER19_TITLE: 'תצוגת האופנה',
    MAGAZINE_H1: 'מגזין קרמבו',
    MAGAZINE1_NAME: 'גיליון מס’ 2',
    MAGAZINE1_DATE: 'ספטמבר 2015',
    MAGAZINE2_NAME: 'גיליון מס’ 3',
    MAGAZINE2_DATE: 'מאי 2016',
    MAGAZINE3_NAME: 'גיליון מס’ 4',
    MAGAZINE3_DATE: 'ינואר 2017',
    MAGAZINE4_NAME: 'מגזין דפוס',
    ACTIVITY_h1: 'אירועי התרמה - קרמבו של קיץ',
    ACTIVITY_PROJECT1_TEXT: 'קרב הדיוות הגדול',
    ACTIVITY_PROJECT2_TEXT: 'קיציס ואירנה חולמים קרמבו',
    ACTIVITY_PROJECT3_TEXT: 'פאודה – גרסת קרמבו',
    ACTIVITY_PROJECT4_TEXT: 'ירון ברלד מחקה את נינט',
    ACTIVITY_PROJECT5_TEXT: 'משיח" וקרמבו של קיץ"',
    ACTIVITY_PROJECT6_TEXT: 'מופע הסטנד אפ של  עדי גולדשמיט',
    view: 'עיין',
    STORY_LINK: 'ערוץ היוטיוב שלנו',
    isHebrew: true,
    langString: 'he',
};
exports.reports = {
    REPORT1: 'דוח כספי 2016',
    REPORT2: 'דוח מילולי 2016',
    REPORT3: 'דוח כספי 2015',
    REPORT4: 'דוח מילולי 2015',
    REPORT5: 'דוח 5 מקבלי השכר 2015',
    REPORT6: 'דוח כספי 2014',
    REPORT7: 'דוח מילולי 2014',
    REPORT8: 'דוח מקבלי השכר 2014',
    REPORT9: 'דוח כספי 2013',
    REPORT10: 'דוח מילולי 2013',
    REPORT11: 'דוח מקבלי השכר 2013',
    REPORT12: 'דוחות כספיים ליום 31 בדצמבר 2012',
    REPORT13: 'דוח מילולי 2012',
    REPORT14: 'מקבלי השכר מקוון 2012',
    REPORT15: 'דוחות כספיים ליום 31 בדצמבר 2011',
    REPORT16: 'דוחות כספיים ליום 31 בדצמבר (דוח מילולי) 2011 ',
    REPORT17: 'רשימת 5 מקבלי השכר הגבוה בעמותה 2011',
    REPORT18: 'דוחות כספיים ליום 31 בדצמבר 2010  ',
    REPORT19: 'דוחות כספיים ליום 31  בדצמבר (דוח מילולי) 2010 ',
    REPORT20: 'אישור לצורך ניכוי מס',
    REPORT21: 'אישור ניהול פנקסים',
    REPORT22: 'אישור ניהול תקין לשנת 2019 ',
    REPORT23: 'טופס 4 עד דצמבר 2020   ',
    REPORT24: 'תקנון העמותה',
    REPORT25: 'פוליסת ביטוח תאונות אישיות',
    REPORT26: 'תקנון הגרלת "חלום כפול"',
    REPORT27: 'חוזר למחנה קיץ 2019',
    REPORT28: 'טופס ביטול הרשמה למחנה קיץ 2019 וורד',
    REPORT30: 'דוח כספי 2017',
    REPORT31: 'דוח כספי 2018',
    REPORT32: 'ניהול פנקסים 2020',
    REPORTS_H1: 'סינון לפי:',
    LANGUAGE: 'heb',
    reports: 'דו”חות',
    ishurim: 'אישורים',
    appendixes: 'נספחים',
    view: 'עיין',
    ishurFilter: 'אישור',
    takanonFilter: 'תקנון ',
    takanonFilter1: 'פנקסים',
    takanon: 'תקנון העמותה',
    tisa: 'תקנון הגרלת כרטיסי טיסה',
};
////////// thankyou page ///////////
exports.thanks = {
    BTN: 'חזרה לעמוד הבית',
    success: 'הרשמתך נקלטה בהצלחה!',
};
exports.event = {
    form_h1: 'יעד התרומה',
    form_h2: 'מופע התרמה יובל שר 2019',
    form_h3: '*כל ההכנסות קודש לילדי “כנפיים של קרמבו”',
    name: 'שם',
    phone: 'טלפון',
    email: 'מייל',
    id: 'ת”ז/ח”פ',
    id_error: 'אנא הזן ת”ז/ח”פ',
    messgae: 'הודעה',
    send: 'צור קשר',
    managers_h1: 'מטה העמותה',
    name_fill: 'אנא הזן שם ושם משפחה',
    phone_fill: 'אנא הזן מספר טלפון',
    email_fill: 'אנא הזן מייל',
    subject_fill: 'אנא בחר נושא',
    bad_phone: 'שגיאה במספר טלפון',
    bad_email: 'שגיאה בכתובת אימייל',
    send_succeded: 'בקשתך נשלחה',
    newlatter_p:
        'הנני מאשר/ת קבלת דיוור ו/או חומר פרסומי מעמותת “כנפיים של קרמבו”',
    round_up_p: 'הנני מעוניין/ת לעגל לטובת עמותת “כנפיים של קרמבו“',
    ticket_type: 'סוג כרטיס',
    ticket_500: ' יציע 500 ₪',
    ticket_750: ' אולם 750 ₪',
    ticket_1800: ' חוג הידידים 1800 ₪',
    ticket_amount: 'כמות כרטיסים',
    ticket_total: 'סה"כ',
    tickets_aside: '*כרטיסים ימתינו לרוכשים בקופה ביום האירוע',
    tickets_submit: 'להמשך תרומה',
    till: 'עד למופע',
    minutes: 'דקות',
    hours: 'שעות',
    days: 'ימים',
    blessing: 'הוסיפו את הברכה האישית שלכם (לא חובה)',
};
exports.donate = {
    header: 'בואו נבטיח שלכל הילדים יהיו חברים, בואו ניצור יחד מקום ומשמעות לכל אדם.',
    form_h1: 'זה​ ממש ​קצר ​-​ תתחילו​ כאן:​',
    form_holiday_card: 'בחרו את הברכה שתרצו לשלוח',
    this_way: 'או​ שאפשר​ גם ​ככה:​',
    first_box_h2: 'להרים טלפון למוקד',
    first_box_p: '077-9555547 או למשרדינו בטלפון 09-8852385',
    second_box_h2: 'לכתוב צ׳ק',
    second_box_h5: 'כתובתנו - רח׳ הנביאים 17 רמה״ש 4727919 ת.ד 1166',
    second_box_p_1: 'לפקודת',
    second_box_p: '“כנפיים של קרמבו” ',
    third_box_h2: 'להעביר לחשבון',
    third_box_h5:
        'בנק הפועלים (12), סניף שאול המלך (532) רח דניאל פריש 3 תל אביב מס חשבון 665538',
    third_box_p: 'העמותה - חשבון ע”ש כנפיים של קרמבו',
    language: 'hebrew',
    h1: 'בואו להיות שותפים שלנו',
    text1: 'יצירת מקום ומשמעות לכל אדם, ולאפשר לכל ילד או ילדה עם ובלי צרכים מיוחדים להינות מפעילות חברתית, חוויתית ומעשירה בתנועת הנוער "כנפיים של קרמבו". בעזרתכם נוכל לאפשר לילדים לגעת בחלום, למשפחותיהם כמה שעות של מנוחה והשקעה בילדי המשפחה האחרים, ולחונכי התנועה - חוויה מתגמלת ומעצימה.',
    small_text:
        '*תרומה מאובטחת - אנו מקפידים להשתמש בכל אמצעי האבטחה המחמירים כדי לייצר עבורך תרומה בטוחה.',
    options: 'אפשרויות התרומה',
    options_text1: 'טלפונית למוקד',
    options_text1_1: '077-9555547 או למשרדינו בטלפון 09-8852385',
    options_text2: 'באמצעות המחאה לפקודת ',
    options_text2_1: '"כנפיים של קרמבו" ',
    options_text2_2: ' כתובתנו - רחוב הנביאים 17 רמת השרון 4727919 ת.ד 1166 ',
    options_text4_1:
        ' העברה בנקאית לחשבון העמותה - חשבון ע"ש כנפיים של קרמבו  ',
    options_text4_2: 'בנק הפועלים (12)',
    options_text4_3:
        'סניף שאול המלך (532) רח דניאל פריש 3 תל אביב מס חשבון 665538',
    options_text3:
        'עיגול לטובה היא יוזמה המאפשרת לכם לעשות מעשים טובים בכל יום.',
    options_text3_1:
        'הצטרפו גם אתם לעיגול לטובה, ובכל רכישה שתבצעו באמצעות כרטיס האשראי שלכם, יעוגל סכום הקניה לשקל הקרוב.  האגורות שיעוגלו,יתרמו במלואן לכנפיים של קרמבו.',
    join: 'הצטרפו עוד היום והתחילו לעגל לטובה',
    destination: 'יעד תרומה',
    destination_1: 'כללי',
    destination_2: 'מסע לאתרי הזיכרון בפולין',
    destination_3: 'מחנה קיץ ',
    destination_4: 'הכשרה והדרכה',
    destination_5: 'אימוץ פעיל- חניך או חונך עם /בלי צרכים מיוחדים',
    destination_6: 'אומנות',
    person_details: 'קבלה על שם ',
    name: 'שם מלא/חברה (קבלה על שם)',
    receiver_name: 'שם המקבל',
    sender_name: 'שם השולח',
    phone: 'טלפון',
    address: 'כתובת',
    city: 'עיר',
    email: 'מייל',
    receiver_email: 'מייל המקבל',
    who_to_send_holiday_card_to: 'למי לשלוח?',
    id: 'ת”ז ח”פ',
    notes: 'האם תרצו לתרום למטרה מסויימת?',
    who_sent_it_holiday_card_to: 'מי השולח?',
    or: 'או',
    keva: 'הוראת קבע - מהיר וקל',
    submit: 'המשך לתרומה',
    project: 'יעד תרומה',
    name_insert: 'אנא הזן שם ושם משפחה',
    phone_insert: 'אנא הזן מספר טלפון    ',
    address_insert: '   ',
    city_insert: '',
    email_insert: 'אנא הזן אימייל ',
    id_insert: 'אנא הזן מספר ת"ז/ח"פ',
    insert_total: 'אנא הזן סכום',
    bad_email: 'שגיאה בכתובת אימייל ',
    bad_phone: 'שגיאה במספר טלפון ',
    amount: 'סכום',
    min_amount: 'סכום מינימלי 1 ש"ח',
    chose_project: 'יעד תרומה',
    newlatter_p:
        'הנני מאשר/ת קבלת דיוור ו/או חומר פרסומי מעמותת “כנפיים של קרמבו”',
    round_up_p: 'הנני מעוניין/ת לעגל לטובת עמותת “כנפיים של קרמבו“',
    general: 'כללי',
    error_top: 'אירעה תקלה, תרומתך לא התקבלה.',
    bottom: ' חשבונך לא חוייב',
    try_again: 'נסה שנית',
    sender_email: 'מייל השולח',
    choose_a_blessing: 'אנא בחר/י כרטיס',
    blessing: 'הוסיפו את הברכה האישית שלכם (לא חובה)',
    generalWarningMessage: 'אנא השלם את הפרטים החסרים',
};
exports.branches = {
    h1: 'רשימת סניפים ושעות פעילות',
    search: 'חיפוש סניף',
    activity_day: 'יום פעילות',
    working_hours: 'שעות פעילות',
    activity_day_senios: 'יום פעילות חונכים',
    branch_manager: 'מרכז/ת סניף',
    senior_manager: 'רכז/ת בוגר/ת',
    managers_h1: 'בעלי תפקידים - מטה שטח',
    ACTIVE_DAY: 'יום פעילות שכבג',
    ACTIVE_HOURS: 'שעות פעילות שכבג',
};
exports.about = {
    values_h1: 'אודות כנפיים של קרמבו',
    value1_h3: 'הובלת שינוי חברתי',
    value1_p:
        "כנפיים של קרמבו' היא תנועת נוער לצעירים עם ובלי צרכים מיוחדים. כן, אנחנו תנועת נוער לכל דבר ופעילי התנועה לא רואים בפעילותם 'עשייה התנדבותית' , אלא עשייה חברתית וחווייתית - למען עצמם ולמען אחרים.",
    value2_h3: 'קיום פעילות חברתית חינוכי',
    value2_p:
        "פעילות חברתית-חינוכית, בלתי פורמאלית, פעם בשבוע בשעות אחה'צ, במודל של חונכות אישית-במסגרת קבוצתית. מרבית החונכים הינם בני נוער מהחינוך הכללי. הפעילות המשותפת תורמת להגברת המודעות לאוכלוסיות מיוחדות ולנגישות חברתית.",
    value3_h3: 'יוצרים מקום ומשמעות לכל אדם',
    value3_p:
        'אנו פועלים מתוך אמונה כי לכל הילדים-ללא הבדלי יכולת, מוצא, דת או מגדר, יש צורך משותף: כל הילדים רוצים וצריכים להרגיש שייכות חברתית ולכל ילד מגיע ליהנות בין חברים.',
    value4_h3: 'מחויבות להנגשה מלאה',
    value4_p:
        "מקום פעילות נגיש, הסעת חניכים מביתם למקום הפעילות וחזרה, בהסעות המותאמות לנכים, ההסעה מפוקחת ומלווה ע'י פעיל של התנועה, בכל פעולה. מטפלת סיעודית, המסייעת בצרכים האינטימיים של הפעילים, במהלך הפעילות, בכל אחד מסניפי התנועה.",
    started_h2: 'אודות התנועה',
    started_section1_h3: 'בבית משפחת קובי, נולדה "רוח קרמבו"',
    started_section1_p:
        'כנפיים של קרמבו´ הינה תנועת נוער, מובילת שינוי חברתי, הראשונה והיחידה מסוגה בעולם, לילדים ונוער עם ובלי צרכים מיוחדים. בתנועה אלפי פעילים - ילדים ובני נוער, צעירים בשנת שירות וסטודנטים. פעילי התנועה רואים בכנפיים של קרמבו את תנועת הנוער שלהם ואינם מתייחסים לעשייה בה "התנדבות".',
    started_section2_h3: 'מ"רוח קרמבו" ל"כנפיים של קרמבו"',
    started_section2_p:
        '´כנפיים של קרמבו´ מקיימת פעילות חברתית-חינוכית, בלתי פורמאלית, פעם בשבוע בשעות אחה"צ, במודל של חונכות אישית-במסגרת קבוצתית. מרבית החונכים הינם בני נוער מהחינוך הכללי. הפעילות המשותפת תורמת להגברת המודעות לאוכלוסיות מיוחדות ולנגישות חברתית, תוך מתן מענה לצרכיהם הרגשיים והחברתיים והשתלבותם בחברה הישראלית של אנשים עם צרכים מיוחדים.',
    started_section3_h3: 'משק הכנפיים הגיע לכל רחבי הארץ',
    started_section3_p:
        '´כנפיים של קרמבו´ קולטת ילדים רבי נכויות (מגבלות פיזיות/ קוגניטיביות/ מרחביות/ חושיות/ תקשורתיות) ונותנת  מענה לצרכים החברתיים שלהם, במכוונות לפיתוח מיומנויות חברתיות, בינם לבין עצמם, ובינם לבין החונכים שלהם. ',
    started_section3_p_2:
        'הפעולות המועברות בתנועה עוסקות בנושאים שעל סדר יומה של החברה הישראלית והחברה האוניברסאלית ובנוסף מתקיימות פעילויות של תרומה לקהילה במקומות בהם פועלים סניפי התנועה.  ',
    started_section4_p:
        '´כנפיים של קרמבו´ מחויבת להנגשה מלאה של פעילותה: מקום פעילות נגיש, הסעת חניכים מביתם למקום הפעילות וחזרה, בהסעות המותאמות לנכים, ההסעה מפוקחת ומלווה ע"י פעיל של התנועה, בכל פעולה. מטפלת סיעודית, המסייעת בצרכים האינטימיים של הפעילים, במהלך הפעילות, בכל אחד מסניפי התנועה. פעילות מונגשת באמצעות מכשירי תקשורת חלופית, שפת סימנים, סמלי PCS וכד  והנגשה כלכלית באמצעות תשלום דמי הרשמה סמליים בלבד.',
    structure_h1: 'מבנה התנועה',
    milestones_h1: 'ציוני דרך',
    active: 'פעילים',
    branches: 'סניפים',
    opened_this_year: 'סניפים שנפתחו בשנה זו',
    managers_h1: 'חברי ההנהלה',
    contact: 'צור קשר',
    vaad: 'ועד מנהל ',
    vision_h1: 'חזון התנועה',
    vision_h2: 'יוצרים יחד מקום ומשמעות לכל אדם',
    vision_section1_h3: 'החזון משקף את רוחה של התנועה ואת הקוד האתי שלה',
    vision_section1_p:
        'יצירה משותפת של מקום משמעותי, תורם ובעל השפעה עבור כל אחד מהפעילים, בין אם הוא בעל צרכים מיוחדים ובין אם לא.',
    vision_section2_h3:
        'את פעילות בתנועה מובילים בני נוער, עם ובלי מוגבלויות, המגיעים מרקע חברתי ותרבותי מגוון',
    vision_section2_p:
        'פעילי התנועה הם דור העתיד שיעצב את דמותה של החברה הישראלית, ברוח ערכי השוויון החברתי, תוך דאגה ומחשבה על רווחת כלל האוכלוסיות המרכיבות את החברה הישראלית.',
    vision_last_h4:
        'המשימה הניצבת בפני התנועה: להקים סניף בכל יישוב וקהילה בישראל על מנת לאפשר שוויון הזדמנויות חברתי, חיי חברה ושייכות חברתית',
    last_h1: 'דברי המנכלית',
    last_p1:
        '´כנפיים של קרמבו´ מחוללת מהפכה שקטה, עוצמתית ומשמעותית בחברה הישראלית מאז שנת 2002. אלפי ילדים ובני נוער עם ובלי צרכים מיוחדים, פעילים בעשרות סניפים ברחבי הארץ ומעידים על כך שהכללה, הכלה, שילוב ושוויון הזדמנויות אינן ססמאות אלא עשייה חברתית מלאת תוכן ותרומה לכל העוסקים בה.',
    last_p2:
        '´כנפיים של קרמבו´ מעניקה לילדים מיוחדים את הפעילות החברתית שכה חסרה בחייהם ומערה אותם בקהילה על מנת שיוכלו לפתח את כישוריהם החברתיים. יחד עם בני נוער מהחינוך הכללי, מכל שכבות האוכלוסייה ורבדיה בכל הארץ, הם הופכים יזמים חברתיים העושים למען הקהילה, פותחים סניפים בהם משולבים ילדים ובני נוער עם ובלי מוגבלויות ומשנים את פני החברה הישראלית - לטובה.',
    last_p3:
        '´כנפיים של קרמבו´ משמעותית עבור פעיליה, מעניקה להם מעגל השתייכות חברתית ומסייעת להם לגבש את זהותם. הפעילים הינם שגרירים-של-רצון-טוב, המפיצים את את ערכי התנועה לכל מעגלי החיים שלהם; משפחה, חברים וקהילה ומהווים מודל לחיקוי של קבלת והכלת השונה.',
    last_p4:
        '´כנפיים של קרמבו´ הינה תנועת נוער בהווייתה – תנועה העונה על כל מרכיבי ההגדרה הקלאסית של חינוך בלתי פורמלי; מעורבות חברתית, שותפות בקבלת החלטות, אוטונומיה, נוער למען נוער, תרבות, אידיאולוגיה, סמלים, מדים ועוד.',
    last_p5:
        'אנו מאמינים כי ´כנפיים של קרמבו´ הוכיחה שהיא ראויה להיכלל במניין תנועות הנוער וכי היא זו אשר מקדמת את זכותם של ילדים ונוער עם מוגבלויות מורכבות ורבי נכויות- להשתייך לחברת השווים שלהם, תוך התאמת הפעילות והנגשתה בכל מובן ואופן-כך שיוכלו להיות חלק פעיל ומוביל בה.',
    last_p6:
        'לדאבון הלב, התנועה עדיין אינה מוכרת ע"י משרד החינוך ואינה מתוקצבת כיתר תנועות הנוער ואנו פועלים לזכות בהכרה רשמית ותקציבית- בזכות ולא בחסד.',
    last_p7:
        '´כנפיים של קרמבו´ הינה פיתוח ישראלי חדשני ונציגיה הוזמנו לייצג את ישראל בכנס באו"ם (נובמבר 2015) מתוך הכרה במודל הייחודי שהיא מציעה כפתרון לסוגיות שילוב איכותי ויעיל של ילדים ונוער עם ובלי צרכים מיוחדים, בארץ ובעולם. ',
    last_p8:
        'אני מזמינה אתכם לבוא ולהכיר את הפעילות, להיות חלק מהעשייה המדהימה המתרחשת בסניפי התנועה. בואו להיות שותפים בחזון ´כנפיים של קרמבו´: יוצרים יחד מקום ומשמעות לכל אדם ולפעול להשגת היעד המיידי- הקמת סניף בכל ישוב בישראל.',
    last_p9: 'שלכם,',
    last_p10: 'טליה בז´רנו , מנכ"לית',
    show_more: 'פרטים נוספים',
    structureBtn: 'לצפיה במבנה התנועה לחצו כאן',
    isHebrew: true,
};
exports.signup = {
    header_h1: 'הרשמת פעילים',
    header_text_1:
        'תנועת "כנפיים של קרמבו" מזמינה אתכם להירשם לפעילות שנתית, עשירה ומגוונת, לחונכים וחניכים כאחד. העלות השנתית לפעיל בתנועה הינה סמלית, (פעיל חדש חייב ברכישת חולצת מדים, פעיל ותיק יכול לרכוש חולצה נוספת, עלות החולצה 50 ש"ח נוספים).',
    header_text_2:
        'התשלום נגבה באופן זהה מכל הפעילים בתנועה (חונכים וחניכים כאחד) מתוך תפיסה שכולם פעילים בתנועת הנוער כנפיים של קרמבו באופן שיוויוני וזהה ונתרמים מהפעילות המשותפת במידה שווה.',
    header_small:
        '* שימו לב - בבקשה לא לרשום חניכים חדשים ( עם צרכים מיוחדים) לפני שנוצר קשר ראשוני עם הסניף, הובהר שיש מקום, נערך ביקור היכרות בבית החניך וסוכם על התאמה הדדית של הילד לפעילות.',
    header_btn: ' הרשמה לפעיל',
    docs_h1: 'מסמכים',
    doc1_text: 'מכתב פתיחת שנה לפעילים והוריהם 20-21',
    doc2_text: 'מדיניות ביטולים 20-21',
    doc3_text: 'טופס ביטול והחזר דמי רישום שנתיים',
    doc4_text: 'טופס ביטול הרשמה לסמינרים ומפעלים',
    doc5_text: 'מפעל אביב לשכבה בוגרת 2019',
    doc6_text: 'טופס ביטול והחזר דמי רישום מפעלי אביב 2019',
    doc8_text: 'טופס ביטול הרשמה למחנה קיץ',
    doc7_text: 'חוזר למחנה קיץ 2019',
    view: 'עיין',
    adopt_h2:
        'אם ברצונכם לאמץ פעיל ממשפחה מעוטת יכולת  ולסייע לו לשלם את דמי ההרשמה כל תרומה תתקבל בברכה!',
    adopt_btn: 'לאימוץ לפעיל',
};
exports.footer = {
    donate: 'לתרומה',
    contact: 'צור קשר',
    knowladge: 'מרכז ידע',
    knowladge_1: 'חזון וערכי התנועה',
    knowladge_2: 'טקסטים וסמלים',
    knowladge_3: 'פעילות התנועה',
    knowladge_4: 'התפיסה החינוכית',
    press: 'מן התקשורת',
    press_1: 'פרויקטים קרמבואיים',
    press_2: 'אירועי התרמה',
    press_3: 'מן העיתונות',
    press_4: 'מגזין קרמבו',
    about: 'אודות',
    about_1: 'הערכים שלנו',
    about_2: 'איך הכל התחיל',
    about_3: 'מבנה התנועה',
    about_4: 'ציוני דרך',
    about_5: 'חברי ההנהלה',
    about_6: 'ועד מנהל',
    about_7: 'חזון התנועה',
    about_8: 'דיברי המנכלית',
    last_section_1: 'כנפיים של קרמבו',
    last_section_2: '(ע”ר) 580455681',
    last_section_3: 'כתובת ',
    last_section_4: ' רחוב הנביאים 17 רמת השרון 4727919 ',
    last_section_5: ' ת.ד ',
    last_section_6: '1166',
    last_section_7: 'דואר אלקטרוני ',
    last_section_8: 'krembo@krembo.org.il',
    last_section_9: 'לפניות היכנסו לצור קשר',
    last_section_10: 'מענה קולי 24 שעות ביממה',
    last_section_11: 'משרד',
    last_section_12: '09-8852385',
    last_section_13: '8849*',
};
exports.contact = {
    form_h1: 'צור קשר',
    name: 'שם',
    phone: 'טלפון',
    email: 'מייל',
    subject_select: 'נושא',
    subject_1: 'תרומות',
    subject_2: 'הרשמת פעילים',
    subject_3: 'דרושים',
    subject_4: 'כללי',
    messgae: 'הודעה',
    send: 'צור קשר',
    managers_h1: 'מטה העמותה',
    name_fill: 'אנא הזן שם ושם משפחה',
    phone_fill: 'אנא הזן מספר טלפון',
    email_fill: 'אנא הזן מייל',
    subject_fill: 'אנא בחר נושא',
    bad_phone: 'שגיאה במספר טלפון',
    bad_email: 'שגיאה בכתובת אימייל',
    send_succeded: 'בקשתך נשלחה',
};
exports.educational = {
    h1: 'התפיסה החינוכית',
    h2: 'אנחנו שואפים לחיבור ושיתוף',
    h3: 'כנפיים של קרמבו היא תנועת נוער שפועלת לחיבור ולשיתוף בין צעירים עם מוגבלויות, לבין צעירים ללא מוגבלויות, בני גילם, דרך פעילות חברתית משותפת. אנו מאמינים שיצירת בסיס למפגשים משותפים, תוביל להבנה הדדית, תיצור הזדמנות לקשרים חברתיים ולשינויי תפיסות ועמדות כלפי אנשים עם מוגבלויות.',
    section1_h3: 'התפיסה החינוכית שלנו מעצימה גם את החונכים',
    section1_p:
        'הטמעת המושגים עצמאות, יכולת והובלה במובנם הרחב והתמקדות בראייה החיובית, מחזקת את גם את החונכים בתנועה. כבני נוער המתבגרים בחברה הישגית, מובילה הגישה החינוכית הנהוגה בתנועה, לתחושת שחרור וביטחון המאפשרת התנסות והובלה.',
    section2_h3: 'מקור התפיסה החינוכית',
    section2_p:
        "התפיסה החינוכית עליה מבוססת פעילות התנועה גובשה על-ידי הגב' קלאודיה קובי, אם-מייסדת.",
    section2_p2:
        'מקור ההשראה המשמעותי ביותר עבור קלאודיה, היה בנה כפיר, אותו היא מכנה המורה והמנהיג הכי חשוב שלי. כפיר, אשר לא זכה להגיע לבגרות, היה ילד עם מוגבלויות מורכבות-לא דיבר ולא הלך, אולם תקשר עם הסביבה והיה נחוש להיות שותף לחיי המשפחה והסביבה, להיות שייך ולקחת חלק בכל העשייה סביבו.',
    section3_h3: 'כבוד האדם, ללא קשר למגבלתו או למוגבלותו.',
    section3_p:
        'נקודת המוצא שלנו היא להתייחס לאדם בגובה העיניים ולא להסיק מסקנה מהמגבלה הנראית לעין. בשלב ראשון, נתייחס לאדם בהתאם לגילו ואחר כך נתאים את השיח והתקשורת בהתאם לצרכיו וליכולותיו.',
    section4_h3: 'מרכיבי התפיסה החינוכית',
    section4_p:
        'בבסיס התפיסה החינוכית שלנו עומדים שלושה מרכיבים: עצמאות, יכולת והובלה. אנו מתייחסים למושגים אלו שלא כהגדרתם המילונית, ובדרך זו, משנים את ההגדרות המקובלות בחברה.',
    flex_section1_h3: 'הובלה',
    flex_section1_p:
        'אנו רואים בכל אחד את היכולת להוביל. ע"פ תפיסתנו, גם צורך של אדם - נתפס כהובלה. אדם המביע את הצורך שלו ומוביל אחריו אנשים נוספים על מנת לממש את רצונו או רעיונותיו, הוא אדם מוביל! גם אם לשם ביצוע המשימה הוא זקוק לסיוע.',
    flex_section2_h3: 'יכולת',
    flex_section2_p:
        'אנו מאמינים שחשוב להדגיש, להעריך ולשבח את ביצועיו והישגיו של אדם בהתאם ליכולות שלו. להאיר את היכולת הקיימת ולא את המוגבלות. הכרה ביכולות, גם אם הן זעירות, תוביל אותנו כחברה לתפיסה מכילה ומכבדת בה אדם מוערך גם אם יכולותיו מוגבלות. אנו מאמינים כי חיזוק חיובי והדגשת היכולת, תוביל לחיזוק האמונה של האדם בעצמו ותוביל להצלחות נוספות.',
    flex_section3_h3: 'עצמאות',
    flex_section3_p:
        'יכולה לבוא לידי ביטוי בחשיבה, ברצון חופשי, בבחירה, או בכל פעולה קטנה.אנו מעודדים לאתר אצל כל אחד את המקומות בהם הוא יכול להיות שותף אקטיבי בפעילות. תפקידנו לאפשר לכל חניך בעל מוגבלות, להיות חלק מהפעילות על ידי מציאת והדגשת חזקותיו.',
    small_bottom:
        'הוריו של כפיר הבינו שתפקידם, חובתם וזכותם היא לעשות עבורו את ההתאמות הנדרשות והתיווך המתבקש, על מנת לאפשר לו זאת.',
    big_bottom:
        'כך התגבשה התובנה כי הילד המיוחד הוא סך כל מרכיביו: רצונותיו, יכולותיו, אהבותיו, סביבתו וההזדמנויות הנקרות בדרכו, ואין לראות את חייו רק מתוך "נכותו".',
};
exports.activity = {
    h1: 'פעילות התנועה',
    h2: 'ייחודן של פעילויות התנועה נובע מהתאמתן לאנשים עם מוגבלויות.',
    h3: 'אנו מאמינים שעל ידי התאמה ותיווך, ניתן ליצור פעילות חברתית שבה כולם שותפים ולומדים להכיר ולקבל זה את זה.מפגשי התנועה עוסקים בערכים הקשורים לחברה הישראלית, תוך שימת דגש על שינוי עמדות ותפיסות כלפי אנשים עם מוגבלות.',
    first_section_part1_h3: 'חונכים',
    first_section_part1_p: 'בני נוער המשתייכים לכל קצוות החינוך הכללי בישראל.',
    first_section_part2_h3: 'חניכים',
    first_section_part2_p:
        'צעירים עם מוגבלויות: פיזיות, קוגניטיביות, חושיות, תקשורתיות ועוד.',
    second_section_h3:
        'בזמן הפעילות תפקיד החונכים הוא לשמש כגורם המתווך לחניכים את הפעולה בהתאם לצרכיהם - ברמה פיזית, קוגניטיבית או תקשורתית.',
    second_section_p: 'היכרות מעמיקה עם החניכים ותמיכה בחונכים',
    flex_part1_h3: 'אינטואיטיביות',
    flex_part1_p:
        'אנו מחזקים גם את הקשר האישי והפתרונות האינטואיטיביים של החונכים בפעילות עם החניכים. מניסיוננו, קשר חדש של בן נוער אשר יש בו מידה של נאיביות, והוא מבוסס על ראייה חיובית, עשוי לעודד הזדמנויות חדשות עבור החניך.',
    flex_part1_h5: 'קשר אינטואטיבי מעודד הזדמניות חדשות לחניך',
    flex_part2_h3: 'הכשרות',
    flex_part2_p:
        'כל בעלי התפקידים בתנועה לוקחים חלק בהכשרות, המכינות אותם לעבודה עם החניכים. ההכשרות נותנות מקום לשאלות ולהתלבטויות של החונכים בהקשר של מפגש עם החניכים. אנו נותנים לגיטימציה, מקבלים ומכילים את התחושות של החונכים, גם אם הם חווים תחילה רתיעה מהמפגש עם חניך בעל מוגבלות. אנו מחזקים אותם ומחדדים שהתחושה לגיטימית.',
    flex_part2_h5: 'דיון בשאלות הקשות, מוביל להבנה ולקבלה של האחר.',
    flex_part3_h3: 'מפגשי היכרות',
    flex_part3_p:
        'אנו רואים חשיבות גדולה במפגשי היכרות בבית החניך, המאפשרים היכרות מעמיקה עם החניך ומשפחתו. הביקורים מאפשרים להכיר את הסביבה הטבעית של החניך, לקבל מידע ותובנות אודותיו ומידע על הצרכים השונים שלו מהוריו. מפגשי ההיכרות מהווים את ראשית הקשר בין התנועה למשפחה.',
    flex_part3_h5: 'הביקורים מאפשרים היכרות מעמיקה על החניך ומשפחתו',
    attitude_h3: 'גישת חונך כמתווך - מודל חניכה ייחודי',
    attitude_p1: 'מטרת התיווך בין חונך וחניך היא לאפשר ולא "לעשות במקום".',
    attitude_p2:
        'המתווך הוא אדם אשר נמצא לצד האדם הזקוק לתיווך. הוא מספק רק את התמיכה הנדרשת על מנת לאפשר לחניך לקחת חלק פעיל בסיטואציה.',
    attitude_p3: 'החונך הוא שותף של החניך בפעילות וחווה אותה יחד עמו.',
    attitude_p4: 'החונך צריך לזהות את המקומות בהם עליו לקחת צעד אחד אחורה.',
    attitude_p5:
        'הרגעים בהם חניך עם מוגבלות מצליח ללא עזרה ותמיכה, הם רגעים מאוד משמעותיים עבורו.',
    attitude_gray:
        'גישת חונך כמתווך, מיישמת את העקרונות הגישה המקצועית ובאה לידי ביטוי באופנים הבאים',
    last_flex1_h3: 'עידוד לעצמאות',
    last_flex1_p:
        'אנו מעודדים מתן הזדמנות להתנסות עצמאית, לכן נחפש תמיד את הדרך המתאימה לכל חניך להיות שותף פעיל ועצמאי, עד כמה שניתן, בפעילות. בנוסף, אנו מטמיעים את המושג "תיווך במידה" אנו מעודדים את החונכים לתווך במידה על מנת לאפשר את עצמאות החניך. לדוגמה: מוטב שתוצאה של עבודת יצירה לא תהיה מושלמת, אך תהיה תוצאה של עבודה משותפת של החניך והחונך, מאשר יצירה מושלמת שבה החניך רק ישב והתבונן.',
    last_flex2_h3: 'הבנה והקשבה',
    last_flex2_p:
        'הבנה והקשבה מהוות חלק משמעותי בתהליך החונכות. חשוב להבין ולהכיר את מאפייני הנכות של החניך, מוגבלויותיו ויכולותיו, הסיבות להתנהגויות השונות שלו, המצבים המאתגרים שייתכן וייווצרו ואת הצרכים והרצונות המידיים בזמן הפעילות.',
    last_flex3_h3: 'כבוד האדם',
    last_flex3_p:
        'כל חניך מגיע מרקע שונה, לכל חניך יכולות ומוגבלויות הייחודיות לו, אהבות ורצונות שונים, וכל חניך נחשף לעולם שונה של הזדמנויות וחוויות. כל אלו מעצבים את אישיותו ומשפיעים על ידיעותיו ויכולותיו. לכן, כשאנו נגשים לשוחח עם חניך, אנו עשויים למצוא שונות גדולה בין אדם לאדם, על אף שהוא נמנה על אותה קבוצת ייחוס. לאור זאת, נפנה לכל חניך בצורה טבעית, רגילה ומכבדת. לאחר היכרות מעמיקה יותר עמו, נדע מה רמת ההבנה שלו ונתאים את עצמנו לרמה זו.',
    last_flex4_h3: 'ראייה חיובית',
    last_flex4_p:
        'בחינת כל סיטואציה מתוך כוונה לאפשר ולהביא כל חניך לחוויית הצלחה, תוך איתור והדגשת הכוחות והיכולות ולא את הקשיים.',
    last_flex5_h3: 'נגישות והתאמה',
    last_flex5_p:
        'החונך מתאים ומתווך את הפעילות באופן אישי, ובהתאמה לחניך שלו. ההתאמה יכולה לבוא לידי ביטוי בדרכי התקשורת עם החניך, בהתאמות לפעילויות יצירה ובתמיכה בפעילות קבוצתית ומוטורית.',
};
exports.vision = {
    h1: 'חזון וערכי התנועה',
    create_h2: 'יוצרים יחד מקום ומשמעות לכל אדם',
    create1_h3: 'החזון משקף את רוחה של התנועה ואת הקוד האתי שלה',
    create1_p:
        'יצירה משותפת של מקום משמעותי, תורם ובעל השפעה עבור כל אחד מהפעילים, בין אם הוא בעל צרכים מיוחדים ובין אם לא.',
    create2_h3:
        'את פעילות בתנועה מובילים בני נוער, עם ובלי מוגבלויות, המגיעים מרקע חברתי ותרבותי מגוון',
    create2_p:
        'פעילי התנועה הם דור העתיד שיעצב את דמותה של החברה הישראלית, ברוח ערכי השוויון החברתי, תוך דאגה ומחשבה על רווחת כלל האוכלוסיות המרכיבות את החברה הישראלית.',
    create3_h3: 'המשימה הניצבת בפני התנועה: להקים סניף בכל יישוב וקהילה בישראל',
    create3_p:
        'על מנת לאפשר שוויון הזדמנויות חברתי, חיי חברה ושייכות חברתית לכל ילד עם צרכים מיוחדים - ללא הבדלי תרבות, מצב סוציואקונומי, דת ומגדר. בנוסף, לשנות תפיסות ועמדות כלפי אנשים בעלי מוגבלויות, בן של צעירים בני אותו גיל והן של החברה הישראלית כולה.',
    circle1_h3: 'אני חבר - ערבות הדדית',
    circle1_p:
        'לדאוג האחד לשני. לקבל את העובדה שאף אחד מאיתנו אינו מושלם. לכבד כל אחד ואת יכולותיו. לעזור, לתמוך לקבל ולתווך.',
    circle2_h3: 'אני אוהב - "ואהבת לרעך כמוך" ',
    circle2_p:
        ' אהבה מתוך ההבנה והיכולת לקבל כל מצב באהבה, גם מצבים קשים. לראות את החיובי ולפעול מתוך שמחה.',
    circle3_h3: 'אני ישראלי',
    circle3_p:
        'כנפיים של קרמבו הוקמה בישראל, מתוך האופי הישראלי המאופיין בשותפות ועזרה לזולת. בכנפיים של קרמבו חברים בני נוער מגווניה השונים של הקשת החברתית בישראל. אנו מובילים את החברה הישראלית לשינוי עמדות ותפיסות כלפי מוגבלות.',
    circle4_h3: 'אני שייך - שייכות, הכלה, הדדיות',
    circle4_p:
        'כל אחד מממש את הפוטנציאל שלו ושותף תורם בעשייה. תפקידנו לאפשר ולעזור לכל אחד לממש את הפוטנציאל שלו. עלינו לדעת לעזור ולהיעזר.',
    circle5_h3: 'אני יכול - יכולת ועצמאות',
    circle5_p:
        'האמונה שלי בעצמי, ביכולת שלי להשפיע ולשנות וברצון שלי לבחור ולהיות עצמאי.',
    circle6_h3: 'אני מוביל - מחויבות, אחריות, מנהיגות',
    circle6_p:
        'כל אחד מאיתנו מנהיג ומקדם את העשייה. כל אחד מאיתנו יכול להוביל לשינוי וכולנו יחד מנהיגים שינוי חברתי.',
};
exports.symbol = {
    h1: 'טקסים וסמלים ',
    h2: 'סמל החזון שלנו',
    symbol_flex1_h3: 'דגל ישראל',
    symbol_flex1_p:
        'מדינת ישראל - המקום ממנו החלה התנועה, והאופי הישראלי לשותפות ועזרה לזולת.',
    symbol_flex2_h3: 'כפיר האריות',
    symbol_flex2_p:
        'מסמל את כפיר קובי, החניך הראשון ומקור ההשראה לתנועה. סמל החזון שלנו מוענק במסדר כנפיים סניפי, לאחר סיום מערך מורשת הכולל פעולות על ערכי התנועה.',
    symbol_flex3_h3: 'הכנפיים',
    symbol_flex3_p:
        'מטרתנו לפרוש כנפיים ולהביא את בשורת ה"שינוי החברתי" לחברה הישראלית ובעתיד גם לחברות שונות בעולם.',
    symbol_bottom1_h3: 'המדים שלנו',
    symbol_bottom1_p:
        'מדי התנועה מהווים סמל ייצוגי ראשון של התנועה וחשובים ליצירת אחידות ושוויוניות. חניכי וחונכי התנועה, יגיעו לפעילות לבושים במדי התנועה, כאשר החולצה בצבע תכלת והעניבה בצבע חום - כצבעי הלוגו של התנועה. על גבי החולצה מופיע סמל התנועה - מלפנים ומאחור.המדים מעוצבים באופן המותאם לחניכים, על ידי שילוב כפתורים מוסתרים, לולאה לעניבה ושרוולים אשר ניתן לקצרם בהתאם לצורך.',
    symbol_bottom1_p2:
        'עניבת התנועה בצבע אחיד מתוך ערך השוויון - כולנו שווים חניכים וחונכים, כולנו יחד חלק מהשלם. עניבת התנועה תחולק בטקס סניפי כחודש לאחר פתיחת השנה. בטקס חותמים החניכים והחונכים על משפט החזון - יוצרים יחד מקום ומשמעות לכל אדם.',
    symbol_bottom2_h3: 'ההצדעה התנועתית',
    symbol_bottom2_p:
        'כמו כל דבר בתנועה, נבחרה מתוך מחשבה על כלל פעילי התנועה, יכולותיהם ומוגבלויותיהם.',
    symbol_bottom2_p2:
        'ההצדעה ממחיזה את סמל התנועה, קרמבו וכנפיים. כל אחת משש האצבעות מייצגת את אחד מערכי התנועה. השימוש בהצדעה יעשה בטקסי תנועה כגון: הענקת סמל החזון, חלוקת עניבות התנועה, שירת התקווה ועוד.',
};
let dropDown7 = [];
Object.keys(branch_parser_1.branchprices).map(function (key, index) {
    dropDown7.push(key);
});
dropDown7 = dropDown7.sort(function (a, b) {
    return a.localeCompare(b);
});
exports.register = {
    form12Text: [
        'בני/בתי זכאי/ת לגמלת ניידות מהמוסד לביטוח לאומי',
        'בני/בתי זכאי/ת לגמלת ילד נכה מהמוסד לביטוח לאומי',
    ],
    TRIAL_SUCCESS: 'נרשמת לתקופת ניסיון בהצלחה',
    TRIAL_CLOSE: 'סגור',
    TRIAL_REG_H1: 'ברוכים הבאים לכנפיים של קרמבו',
    TRIAL_P:
        'תנועת "כנפיים של קרמבו" מזמינה אתכם להירשם לפעילות שנתית, עשירה ומגוונת, לחונכים וחניכים כאחד. העלות השנתית לפעיל בתנועה הינה סמלית, (פעיל חדש חייב ברכישת חולצת מדים, פעיל ותיק יכול לרכוש חולצה נוספת, עלות החולצה 50 ש"ח נוספים) התשלום נגבה באופן זהה מכל הפעילים בתנועה (חונכים וחניכים כאחד) מתוך תפיסה שכולם פעילים בתנועת הנוער כנפיים של קרמבו באופן שיוויוני וזהה ונתרמים מהפעילות המשותפת במידה שווה.',
    TRIAL_LINK: 'לחצו כאן להסבר לגבי דמי ההרשמה והפעילות השנתית.',
    SIGN_END: 'סיים הרשמה',
    ALERRGY_DESC: 'הסבר על האלרגיה',
    NO_ALERGY: 'אין לי אלרגיה',
    YES_ALERGY: 'יש לי אלרגיה/רגישות',
    LETHAL_ALERGY: 'האלרגיה מסכנת חיים',
    ALERGY_TYPE: 'סוג אלרגיה/רגישות',
    YES: 'כן',
    NO: 'לא',
    MEDICAL_EQIUP_EXP: 'אני נעזר/ת בציוד רפואי כגון משאף או ערכת זריקות',
    MEDICAL_EQUIP: 'פירוט הציוד הרפואי',
    I_KNOW: 'ידוע לי כי אין באפשרות התנועה לספק את התנאים למנוע התקף. מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי בגין מצב רפואי ידוע..',
    //header
    PARENTS_INFO: 'פרטי הורים',
    STAGE_ALERGY: 'אלרגיה',
    NEXT_STEP_TRIAL: 'המשך לשלב הבא',
    REMAINING_MEMBERS: 'המשך לתשלום',
    EXISTS_LOCAL: 'פרטים של חניך זה כבר הוזנו למערכת',
    EXISTS: 'חניך זה קיים במערכת',
    EXISTS_BTN: 'מחק חניך',
    EXISTS_BTN2: 'שנה פרטים',
    DISCOUNT: 'הנחה על דמי הרשמה',
    ADD_BROTHER: 'הוסף אח',
    heading: 'ברוכים הבאים לתנועת “כנפיים של קרמבו”.',
    subheader1:
        'אנו מזמינים אתכם להירשם לפעילות שנתית, עשירה ומגוונת, לחונכים וחניכים כאחד. ',
    subheader2: 'להסבר לגבי דמי ההרשמה והפעילות השנתית יש ללחוץ',
    subheader2Link: 'כאן.',
    subheader3: 'להסבר לגבי ביטול ההרשמה יש ללחוץ',
    subheader3Link: 'כאן.',
    paragraph:
        '*העלות השנתית לפעיל בתנועה הינה סמלית, כאשר כל פעיל חדש מחויב ברכישת חולצת מדים (פעיל ותיק יכול לרכוש חולצה נוספת בעלות של ₪50). התשלום נגבה באופן זהה מכל הפעילים בתנועה, חונכים וחניכים כאחד, מתוך תפיסה שכולם פעילים בתנועת הנוער כנפיים של קרמבו באופן שוויוני וזהה לחלוטין.',
    //
    //nav
    stage1: 'פרטי  פעיל',
    stage2: 'אישור הורים',
    stage3: 'סיכום תשלום',
    //
    //forms headers
    firstHeader: 'פרטי פעיל',
    secHeader: 'פרטים אישיים',
    //
    //labels
    gender: 'מין',
    dateOfBirth: 'תאריך לידה',
    //
    //placeholders
    form1Placeholders: ['מין', 'חודש', 'יום', 'שנה'],
    form11Placeholders: ['מעוניין בחולצה נוספת?', 'בחר מידת חולצה'],
    form2placeholders: [
        'שם פרטי',
        'שם בית ספר',
        'מיקוד',
        'שם משפחה',
        'שכבה',
        'סניף',
        'מס’ תעודת זהות',
        'דוא”ל',
        'ניידות',
        'מספר טלפון',
        'עיר',
        'בעל צרכים מיוחדים',
        'וותק פעיל',
        'רחוב ומספר בית',
        'אחוזי נכות',
        'תזונה',
        'קופת חולים',
        'כיתה',
    ],
    //
    tshirtSize: 'בחר מידת חולצה',
    dropDown1: [
        'עצמאי',
        'הליכון',
        'כסא גלגלים',
        'כסא גלגלים ממונע',
        'כסא גלגלים אך יכול ללכת עם עזרה',
        'קושי מוטורי קל',
    ],
    dropDown2: ['פעיל חדש (שנה ראשונה)', 'פעיל ותיק'],
    dropDown3: ['כן', 'לא'],
    dropDown4: [
        '10',
        '12',
        '14',
        '16',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'XL4',
    ],
    dropDown5: ['זכר', 'נקבה', 'אחר'],
    dropDown6: [
        "א'",
        "ב'",
        "ג'",
        "ד'",
        "ה'",
        "ו'",
        "ז'",
        "ח'",
        "ט'",
        "י'",
        "יא'",
        "יב'",
    ],
    dropDown7,
    dropDown8: ['כן', 'לא'],
    dropDown13: ['רגיל', 'צמחוני', 'טבעוני', 'רגישות לגלוטן'],
    dropDown14: ['כללית', 'מכבי', 'מאוחדת', 'לאומי', 'אין'],
    aproveTermsEmpty: 'אנא אשר תקנון התנועה',
    firstNameEmpty: 'אנא מלא שם פרטי',
    lastNameEmpty: 'אנא מלא שם משפחה',
    schoolNameEmpty: 'אנא מלא את שם בית הספר',
    streetEmpty: 'אנא מלא כתובת',
    cityEmpty: 'אנא מלא עיר',
    mobillityEmpty: 'אנא בחר מידת ניידות',
    vetekEmpty: 'אנא בחר ותק חניך',
    anotherTshirtEmpty: 'אנא בחר האם הינך מעוניין בחולצה נוספת',
    sizeTshirtEmpty: 'אנא בחר מידת חולצה',
    genderEmpty: 'אנא בחר מגדר',
    classEmpty: 'אנא בחר שכבה',
    classNumberEmpty: 'אנא מלא כיתה',
    branchEmpty: 'אנא בחר סניף',
    specialNeedsEmpty: 'אנא ציין האם החניך בעל צרכים מיוחדים',
    dietEmpty: 'אנא בחר תזונה',
    hmoEmpty: 'אנא בחר קופת חולים',
    monthEmpty: 'אנא הזן חודש',
    dayEmpty: 'אנא הזן יום',
    yearEmpty: 'אנא הזן שנה',
    dayInvalid: 'יום לא תקין',
    yearInvalid: 'שנה לא תקינה',
    emailEmpty: 'אנא מלא כתובת דואר אלקטרוני',
    emailInvalid: 'כתובת דוא"ל לא תקינה',
    idEmpty: 'אנא מלא תעודת זהות',
    idInvalid: 'תעודת זהות אינה תקינה',
    mikudEmpty: 'אנא מלא מיקוד',
    mikudInvalid: 'מיקוד לא תקין',
    phoneEmpty: 'אנא הזן מספר טלפון',
    phoneInvalid: 'מספר טלפון לא תקין',
    btnContinue: 'המשך',
    //form2
    parent1fullNameEmpty: 'אנא מלא שם מלא של הורה החניך',
    parent1placeOfBirthEmpty: 'אנא מלא תאריך לידה של הורה החניך',
    parent1phoneEmpty: 'אנא מלא טלפון ',
    parent1phoneInvalid: 'מספר טלפון לא תקין',
    parent1workPlaceEmpty: 'אנא מלא מקום עבודה',
    parent1emailEmpty: 'אנא הכנס כתובת דוא"ל',
    parent1emailInvalid: 'כתובת דוא"ל לא תקינה',
    parent2phoneInvalid: 'טלפון לא תקין',
    parent2emailInvalid: 'כתובת דוא"ל לא תקינה',
    declarationStatusEmpty: 'אנא סמן חלק זה',
    // declarationStatusText1: 'אני מצהיר כי לבני/בתי אין כל מגבלה בריאותית',
    // declarationStatusText2:'יש לבני/בתי מגבלות בריאותיות המונעות השתתפות חלקית בפעילות הנדרשת (כגון: אסטמה, סוכרת נעורים, וכדומה)',
    13: ['כן', 'לא', 'ללא אלרגיה'],
    disabillityDescriptionEmpty: 'אנא פרט מגבלות',
    kindOfAlergyEmpty: 'אנא פרט את סוג האלרגיה',
    alergyLethalEmpty: 'אנא בחר שדה',
    approvalText:
        '  ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע חשיפה לאלרגנים/ גורמים מעוררי אפילפסיה ולכל גורם נוסף העלול להוביל ליצירת התקף כלשהו. מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי באם ידרש לכך.',
    approvalEmpty: 'אנא אשר הצהרה',
    typesOfDisabillityEmpty: 'אנא סמן לפחות ערך אחד',
    dropDown10: [
        'ינואר',
        'פברואר',
        'מרץ',
        'אפריל',
        'מאי',
        'יוני',
        'יולי',
        'אוגוסט',
        'ספטמבר',
        'אוקטובר',
        'נובמבר',
        'דצמבר',
    ],
    //2nd page
    parent1: 'הורה 1',
    parent2: 'הורה 2',
    secPageHeading1: 'פרטי הורים',
    secPageHeading3: 'אישור הורים',
    secPageHeading2: 'הצהרת הורים',
    secPageHeading4: 'אישור חשיפה',
    secPageHeading5: 'אישור ליווי נסיעה',
    parentPlaceholders: [
        'שם מלא',
        'ארץ לידה',
        'שנת עליה',
        'מספר טלפון',
        'מקום עבודה',
        'דוא”ל',
    ],
    seizureDropDownPlaceholder: 'תדירות התקפים',
    seizureOccurrenceOptions: [
        'פעם בשנה ויותר',
        'פעם בחצי שנה',
        'פעם בשלושה חודשים',
        'פעם בחודש',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        'שבועי',
        'יומי-מספר התקפים ביום',
    ],
    form3Text: [
        'אני מצהיר כי לבני/בתי אין כל מגבלה בריאותית',
        'יש לבני/בתי מגבלות בריאותיות/רגישויות המונעות השתתפות חלקית בפעילות הנדרשת (כגון: אסטמה, סוכרת נעורים, וכדומה)',
        'פירוט המגבלות הבריאותיות',
        'לבני/בתי יש אלרגיה',
        'לבני/בתי יש אלרגיה מסוג:',
        'אלרגיה מסכנת חיים',
        'לבני/בתי יש קושי בתחומים הבאים (תקשורתית, קוגניטיבית, פיזית, חושית, רגשית, אחר)',
        'סוג הקושי',
        'בני/בתי נעזר/ת בציוד רפואי כגון משאף או ערכת זריקות',
        'פירוט הציוד הרפואי',
        'השימוש נעשה באופן עצמאי',
        'בני/בתי מקבל/ת טיפול תרופתי. ',
        'בני/בתי סובל מאפילפסיה.',
        'פירוט סוגי תרופה ואופן הטיפול בה',
        'מתי קיבל את ההתקף הראשון?',
        'מתי קיבל התקף לאחרונה?',
        'איזה תרופות צורך?',
        'מתי ביקר לאחרונה אצל ניורולוג?',
        'סדר פעולות מומלץ בהתקף',
        'גורמים מעוררי התקף',
        // 'תדירות התקפים',
        'איך נראה התקף?',
        'סימנים מקדימים להתקף',
        `הנני מאשר בזאת כי אין מניעה שבני/בתי ישתתף/תשתתף בפעילות בתנועה למרות הופעת התקפי האפילפסיה.ידוע לי כי במידה ויהיה שינוי בתדירות ובעוצמת ההתקפים של בני / ביתי , או ביכולת הצוות בסניף להתמודד, ייתכן ויהיה צורך בנוכחותי או מבוגר מטעם המשפחה בזמן הפעילות.בחתימתי אני גם מאשר את  הנחייתי שלעיל להתנהלות בעת התקף אפילפסיה של בני / בתי.`,
        "מה גורם להתקף האלרגיה/רגישות (למשל אכילה, מגע, חשיפה לריח וכד') ",
        "במה מתבטא ההתקף( למשל קוצר נשימה, גירוד, שיעול וכד')",
        'מהן ההנחיות לטיפול בזמן התקף',
    ],
    firstSeizureOccurrenceEmpty: 'אנא מלא שדה זה',
    lastSeizureOccurrenceEmpty: 'אנא מלא שדה זה',
    epilepsyDrugsUseEmpty: 'אנא מלא שדה זה',
    lastNeurologistVisitEmpty: 'אנא מלא שדה זה',
    actionSequenceRecommendedEmpty: 'אנא מלא שדה זה',
    seizureCatalistsEmpty: 'אנא מלא שדה זה',
    seizureFrequencyEmpty: 'אנא בחר תדירות',
    howDoesSeizureLookLikeEmpty: 'אנא מלא שדה זה',
    preSeizureSignsEmpty: 'אנא מלא שדה זה',
    seizureTermsApprovalEmpty: 'אנא אשר שדה זה',
    epilepsyNotification: `'כנפיים של קרמבו' תפעל על פי הנחיות ההורה באופן מידי בעת ההתקף, אולם אם ההתקף נמשך מעל 5 דקות, או חוזר על עצמו - יוזעק אמבולנס לסניף, זאת בהתאם להוראות חוזר מנכ"ל משרד החינוך,  תשס"ב/2(א), י"ד תשרי תשס"ב, 1 באוקטובר 2001.לאור האמור לעיל, אנו מבקשים אישורכם לפעילות בנכם / בתכם כדלקמן :`,
    simuLev: '*שימו לב',
    form4Text: [
        'הנני מאשר/ת לבני/בתי להשתתף בפעילות "כנפיים של קרמבו”.',
        `  ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע חשיפה לאלרגנים/ גורמים מעוררי אפילפסיה ולכל גורם נוסף העלול להוביל ליצירת התקף כלשהו.`,
        `מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי בגין מצב רפואי ידוע.`,
    ],
    form5Text: [
        [
            {
                text: 'לא מאשר כלל',
                checked: false,
            },
            {
                text: 'מאשר בתיאום מראש בלבד',
                checked: false,
            },
            {
                text: 'מאשר',
                checked: false,
            },
            {
                text: 'מאשר למטרות מסויימות בלבד',
                checked: false,
            },
        ],
        [
            {
                text: 'שימוש פנימי (במסגרת תצוגה בסניף בלבד - לוח תמונות, מצגות וסרטונים).',
                checked: false,
            },
            {
                text: 'מצגות - הכשרות, סמינרים, גיוסים.',
                checked: false,
            },
            {
                text: "רשתות חברתיות (פייסבוק/אינסטגרם/סנפצ'אט).",
                checked: false,
            },
            {
                text: 'לכל מטרה במסגרת חשיפת הפעילות של התנועה בציבור',
                checked: false,
            },
            {
                text: 'תוכן שיווקי - קמפיינים פרסומיים של התנועה (ארצי/עירוני).',
                checked: false,
            },
            {
                text: 'תקשורת - ארצית/מקומית - עיתונות כתובה/טלוויזיה.',
                checked: false,
            },
        ],
        'ידוע לי כי פרטי בני/בתי מועברים לעיתים לרשות מקומית/משרדי ממשלה/חברות ביטוח לצרכי תמיכה וביטוח.',
        ['הגעה עצמאית', 'מגיעים לאסוף אותו', '(משתנה (לפעמים כך ולפעמים כך'],
    ],
    form6Text: [
        "כחלק מנגישותה של התנועה, 'כנפיים של קרמבו' מעמידה מערך היסעים לפעילות השבועית וממנה, שמאפשר לפעילים שאינם עצמאיים וזקוקים לתיווך אישי,להשתתף בפעילות באופן קבוע. את מערך ההיסעים מלווים בני נוער עצמאיים בגילאי 16-18 הפעילים בסניף. מערכי ההיסעים והכשרת מלווי ההסעות מוחזקים ומועברים בסניפים בהנחיית מחלקת בטיחות ומפעלים של התנועה.",
        'ידוע לי כי בני/בתי עשויים לקחת חלק במערך ההיסעים כמלווים של פעילי התנועה הזקוקים להסעה, ליווי הכרוך בנסיעה ברכב ההסעות.',
        'הנני מאשר/ת לבני/בתי להצטרף למערך ההיסעים, אשר הליווי בו מתבצע על ידי בני ובנות נוער הפעילים בסניף.',
        '        הנני מתחייב להודיע לרכז הבוגר הסניפי על כל שינוי או הגבלה זמניים / קבועים שיחולו במצב הבריאותי של בני/בתי לרבות קבלת חיסון ו/או החלמה מנגיף הקורונה.',
        'שם ההורה המאשר',
        'מס’ ת”ז',
        'דרכי החזרה של בני/בתי מהסניף ביום הפעולה:',
        'אני מאשר/ת שקראתי את תקנון התנועה להלן ומקבל/ת כל התנאים הכתובים בו.',
    ],
    //page 2 validations
    // parent1fullNameEmpty: '1',
    // parent1placeOfBirthEmpty: '1',
    // parent1phoneEmpty: '1',
    // parent1workPlaceEmpty: '1',
    // parent1emailEmpty:'1',
    typeOfAlergyEmpty: 'אנא פרט את סוג האלרגיה',
    typeOfDifficultyEmpty: 'אנא פרט את סוג הקושי',
    medicalEquipmentDescriptionEmpty: 'אנא פרט את הציוד הרפואי',
    parentApprovalEmpty: 'אנא אשר הצהרה',
    parentApproval2Empty: 'אנא אשר הצהרה',
    parentApproval3Empty: 'אנא אשר הצהרה',
    exposureAprrovalEmpty: 'אנא אשר שדה',
    kindOfExposureEmpty: 'אנא בחר מטרה',
    parentApprovalPublicAuthEmpty: 'אנא אשר שדה',
    lastFormParentAproval1Empty: 'אנא אשר הצהרה',
    lastFormParentAproval2Empty: 'אנא אשר הצהרה',
    lastFormParentAproval3Empty: 'אנא אשר הצהרה',
    approvedParentEmpty: 'אנא הזן את שם ההורה המאשר',
    approvedParentIdEmpty: 'אנא הזן תעודת זהות',
    approvedParentIdInvalid: 'תעודת זהות אינה תקינה',
    //
    secondFormSubmitBtn: 'המשך לתשלום',
    finishNoPayForm: 'הרשם',
    //third page
    openYear: 'פתיחת שנה',
    addings: 'פרטים נוספים',
    summery: 'סיכום תשלום',
    register: 'הרשמה',
    shirt: 'חולצה',
    POSITION: 'תפקיד',
    POSITION2: 'תחום אחריות',
    add: 'הוסף',
    added: 'נוסף',
    remove: 'הסר',
    inCaseOfLethalAllergyP:
        'במצב זה, הנך נדרש להמציא הצהרת רופא בנוגע לאלרגיה/רגישות לנוחיותך, מצ״ב פורמט',
    inCaseOfLethalAllergyA: 'לחץ כאן להורדה',
    FIRST_SELECTION: 'חבר צוות מוביל',
    SECOND_SELECTION: 'חבר צוות מנהל',
    registerCost: 'עלות ההרשמה',
    shirtCost: 'עלות הזמנת חולצה',
    totalPay: 'סה”כ:',
    payNow: 'שלם עכשיו',
    requestSent:
        'בקשתך נקלטה במערכת. לאחר אישור פנייתך, ישלח אליך מייל לסיום תהליך ההרשמה.',
    CITIES: cities_1.default.map((m) => m.name),
};
exports.REGISTER_SUCCESS = {
    back_to: 'חזרה לעמוד הבית',
    success: 'ההרשמה בוצעה בהצלחה',
    failed: 'עקב שגיאה, הרישום נכשל',
    back_to_register: 'נסה שנית',
    LOADING_H3: 'מבצע התקשרות',
    LOADING_H2: 'נא לא לצאת מהאתר',
};
exports.TUTOR = {
    NAME: 'שם פרטי*',
    LAST_NAME: 'שם משפחה*',
    ID: 'ת”ז*',
    TYPE: 'סוג פעיל*',
    START_DATE: 'תאריך תחילת פעילות',
    BACK_HOME_TIME: 'שעת חזרה לבית',
    BROTHERS: 'מספר אחים במשפחה',
    ACTIVE: 'האם פעילים בתנועה',
    FRAMEWORK: 'סוג מסגרת חינוכית',
    FRAMEWORK_NAME: 'שם מסגרת חינוכית*',
    HOSTEL: 'הוסטל',
    PICKUP_PLACE: 'מקום איסוף',
    MOADONIT: 'האם החניך נמצא במועדונית',
    PROGRMS_TYPES: ['רגיל', 'משולב', 'כתה קטנה בבה״ס רגיל', 'חינוך מיוחד'],
    PICKUP_PLACES: ['בה״ס', 'מועדונית', 'בית'],
    ADD_PARENT: 'הוסף הורה',
    PARENT_NAME: 'שם הורה*',
    PARENT_PHONE: 'טלפון הורה*',
    PARENT_EMAIL: 'מייל הורה*',
    CLIENT_TYPE: 'סוג לקות*',
    DIA_DESC: 'הגדרת אבחנה*',
    DISABLED_COMPENSATION: 'גמלת ילד נכה*',
    MOBILITY_COMPENSATION: 'גמלת ניידות*',
    REQUIRE_REFERENCE: 'מצבים הדורשים התייחסות*',
    EPILEPSY: 'אפילפסיה',
    CHALLENGING_BEHAVIOUR: 'התקפי זעם / התנהגות מאתגרת',
    REGULAR_MEDICINE: 'תרופות קבועות',
    ALERGYS: 'אלרגיה',
    ALERGYS_OPTIONS: ['מזון', 'תרופות', 'חומר', 'אחר'],
    ALERGYS_DECRIPTION: 'פירוט אלרגיות',
    HOBBYS: 'תחביבים / יכולות מיוחדות',
    ADDITIONAL_CLASSES: 'מסגרות / חוגים נוספים',
    NOTES: 'הערות',
    CLIENT_TYPE_OPTIONS: [
        'תקשורתית',
        'פיזית',
        'קוגניטיבית',
        'חושית',
        'רגשי/התנהגותי',
    ],
    DISABLED_COMPENSATION_OPTIONS: [
        'ללא',
        '50%',
        '75%',
        '100%',
        '150%',
        '188%',
    ],
    MOBILITY_COMPENSATION_OPTIONS: ['כן', 'לא'],
    ERR: 'שדה זה הינו חובה',
    ID_ERR: 'ת״ז שגוי',
    SUCCESS: 'ההרשמה בוצעה בהצלחה',
    ONE_MORE: 'חניך נוסף',
    BACK_HOME: 'עמוד בית',
    EMAIL: 'דוא״ל*',
    EMAIL_ERR: 'שגיאה בדוא״ל',
};
exports.PERSONAL = {
    H1: 'ברוכים הבאים לתנועת “כנפיים של קרמבו”.',
    H2: 'הרשמה אישור הורים, הצהרת בריאות ותשלום בכרטיס אשראי, לשנת הפעילות 2019/20.',
    H3: 'להסבר לגבי דמי ההרשמה והפעילות השנתית יש ללחוץ',
    H3_2: 'להסבר לגבי ביטול ההרשמה יש ללחוץ ',
    INFO: 'פרטים אישיים',
    HERE: 'כאן',
    GENDER: 'מין',
    GENDER_ARR: ['זכר', 'נקבה'],
    EDUCATION_PROGRAM_ARR: [
        'חינוך כללי',
        'חינוך מיוחד',
        'כיתה קטנה בבי"ס כללי',
        'משולב',
        'אחר',
    ],
    MALE: 'זכר',
    FEMALE: '',
    MONTH: 'חודש',
    MONTHS_ARR: [
        'ינואר',
        'פברואר',
        'מרץ',
        'אפריל',
        'מאי',
        'יוני',
        'יולי',
        'אוגוסט',
        'ספטמבר',
        'אוקטובר',
        'נובמבר',
        'דצמבר',
    ],
    HOME_ETA: 'שעת הגעה הביתה',
    PICKUP_LOCATION: 'מקום האיסוף',
    CONTACT_NAME: 'שם איש קשר בבית הספר',
    CONTACT_PHONE: 'מספר טלפון של איש הקשר',
    DAY: 'יום',
    YEAR: 'שנה',
    NAME: 'שם פרטי',
    LAST_NAME: 'שם משפחה',
    SCHOOL: 'שם בית ספר ועיר',
    EDUCATION_PROGRAM: 'סוג מסגרת חינוכית',
    ZIP: 'מיקוד',
    FAMILY: 'שם משפחה',
    SHIHVA: 'שכבה',
    SHIHVA_ARR: [
        "א'",
        "ב'",
        "ג'",
        "ד'",
        "ה'",
        "ו'",
        "ז'",
        "ח'",
        "ט'",
        "י'",
        "יא'",
        "יב'",
    ],
    GRADE: 'כיתה',
    GRADE_ARR: [1, 2, 3, 4, 5, 6],
    BRANCH: 'סניף',
    ID: 'מס’ תעודת זהות',
    VETEK: 'וותק פעיל',
    VETEK_ARR: ['פעיל חדש (שנה ראשונה)', 'פעיל ותיק'],
    PHONE: 'מספר טלפון פעיל',
    EMAIL: 'דוא”ל',
    POSITION: 'תפקיד',
    POSITION_ARR: [
        'חונך (פעיל בשכבה ח-יב)',
        "חניך (קב' חונכויות)",
        'פעיל שכבת ז',
        "פעיל שכבה צעירה ד'-ו",
        'חבר צוות מוביל',
        'חבר צוות מנהל',
    ],
    POSITION_RES: 'תחום אחריות',
    LEAD_TEAM_ARR: [
        'מרכז סניף',
        'רכז חונכויות ',
        'רכז שכב"ג',
        'רכז מפעלים',
        'רכז שכב״צ ד-ו',
        'רכב שכב״צ ז-ח',
    ],
    MANAGEMENT_TEAM_ARR: ['מדריך', 'רכז תקשורת', 'צוות מפעלים', 'צוות תקשורת'],
    HMO: 'קופת חולים',
    HMO_ARR: ['כללית', 'מכבי', 'מאוחדת', 'לאומי', 'אין'],
    ADDRESS: 'רחוב ומספר בית',
    FOOD: 'תזונה',
    FOOD_ARR: ['רגיל', 'צמחוני', 'טבעוני'],
    CITY: 'עיר',
    EXTRA_SHIRT: 'מעוניין בחולצה נוספת?',
    EXTRA_SHIRT_ARR: ['לא', 'כן'],
    SHIRT_SIZE: 'בחר מידת חולצה',
    SHIRT_ARR: [
        '10',
        '12',
        '14',
        '16',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'XL4',
    ],
    SHIRT_ARR_NO_OPTION: [
        '10',
        '12',
        '14',
        '16',
        'S',
        'M',
        'L',
        'XL',
        'XXL',
        'XXXL',
        'XL4',
        '',
    ],
    EXTRA: 'פרטים נוספים',
    SPECIAL_NEEDS: 'בעל צרכים מיוחדים',
    SPECIAL_NEEDS_ARR: ['לא', 'כן'],
    MOBILITY: 'ניידות',
    MOBILITY_ARR: [
        'עצמאי',
        'הליכון',
        'כסא גלגלים',
        'כסא גלגלים ממונע',
        'כסא גלגלים אך יכול ללכת עם עזרה',
        'קושי מוטורי קל',
    ],
    MOBILITY_REWARD: 'בני/בתי זכאי/ת לגמלת ניידות מהמוסד לביטוח לאומי',
    MOBILITY_REWARD_ARR: ['לא', 'כן'],
    CORONA_DETAILS: 'סטטוס חיסון לקורונה',
    CORONA_DETAILS_ARR: ['מחוסן', 'מחלים', 'אינו מחוסן ואינו מחלים'],
    YES: 'כן',
    NO: 'לא',
    DISABLITY_REWARD: 'בני/בתי זכאי/ת לגמלת ילד נכה מהמוסד לביטוח לאומי',
    DISABLITY_REWARD_ARR: ['לא', 'כן'],
    DISABLITY_PERCENT_ARR: ['50%', '75%', '100%', '150%', '188%'],
    NEXT: 'המשך',
    PERCENT: 'אחוז גמלה',
    BIRTH: 'תאריך לידה',
    ADD: 'הוסף אח/ות',
    EXTRA_BROTHER: 'אח/ות נוסף/ת',
    REMOVE_BROTHER: 'הסר אח/ות',
    ERROR_MSG: 'שדה חובה',
    VALIDATION_ERROR: 'תעודת זהות אינה תקינה',
    VALIDATION_ERROR_PHONE: 'מספר טלפון לא תקין',
    VALIDATION_ERROR_ZIP: 'מיקוד לא תקין',
    VALIDATION_ERROR_EMAIL: 'כתובת דוא"ל לא תקינה',
    YEARS_ARR,
    DAYS_ARR,
    GRADES_ARR: [
        'א',
        'ב',
        'ג',
        'ד',
        'ה',
        'ו',
        'ז',
        'ח',
        'ט',
        'י',
        'י״א',
        'י״ב',
    ],
};
exports.PERMISSIONS = {
    DISABILITY_H1: 'מגבלות רפואיות',
    DISABILITY_ARR: [
        {
            text: 'אני מצהיר כי לבני/בתי אין כל מגבלה בריאותית',
            value: false,
        },
        {
            text: "לבני/בתי מגבלות בריאותיות / רגישויות הדורשות התייחסות מיוחדת או מונעות השתתפות בחלק מהפעילות (כגון אסטמה, סכרת נעורים וכו')",
            note: 'במידה ויש רגישות למזון – נא לציין בסעיף של אלרגיה',
            value: true,
        },
    ],
    HOME_ETA: 'שעת הגעה הביתה',
    PICKUP_LOCATION: 'מקום האיסוף',
    CONTACT_NAME: 'שם איש קשר בבית הספר',
    CONTACT_PHONE: 'מספר טלפון של איש הקשר',
    DISABILITY_PLACEHOLDER: 'פירוט המגבלות הבריאותיות',
    ALERGY_H2: 'לבני/בתי יש אלרגיה',
    ALERGY_PLACEHOLDER: 'לבני/בתי יש אלרגיה מסוג:',
    ALERGY_PLACEHOLDER2:
        "מה גורם להתקף האלרגיה/רגישות (למשל אכילה, מגע, חשיפה לריח וכד') ",
    ALERGY_PLACEHOLDER3: "במה מתבטא ההתקף( למשל קוצר נשימה, גירוד, שיעול וכד')",
    ALERGY_PLACEHOLDER4: 'מהן ההנחיות לטיפול בזמן התקף',
    ALERGY_DOC:
        'במצב זה, הנך נדרש להמציא הצהרת רופא בנוגע לאלרגיה/רגישות לנוחיותך, מצ״ב פורמט',
    DOWNLOAD: 'לחץ כאן להורדה',
    LETHAL: 'אלרגיה מסכנת חיים',
    DIFICULTY: 'לבני/בתי יש לקות בתחומים הבאים',
    DIFICULTY_PLACEHOLDER: 'סוג הקושי',
    MEDICAL_EQUIUPMENT: 'בני/בתי נעזר/ת בציוד רפואי כגון משאף או ערכת זריקות',
    // 2021
    CANT_PREVENT:
        'ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע התקף',
    MY_DUTY_TO_PROVIDE:
        'מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי בגין מצב רפואי ידוע.',
    ON_CHANGE_MUST_ALERT:
        'הנני מתחייב להודיע לרכז הבוגר הסניפי על כל שינוי או הגבלה זמניים / קבועים שחלו במצב הבריאותי של בני/בתי',
    //2021 END
    MEDICAL_EQUIUPMENT_PLACEHOLDER: 'פירוט הציוד הרפואי',
    MEDICAL_SELF: 'השימוש נעשה באופן עצמאי',
    DRUGS: 'בני/בתי מקבל/ת טיפול תרופתי.',
    DRUGS_PLACEHOLDR: 'פירוט סוגי תרופה ואופן הטיפול בה',
    EPILEPSY: 'בני/בתי סובל מאפילפסיה.',
    CAN_RELIEVE_HIMSELF_DESCRIPTION: 'אנא פרט את סוג הסיוע',
    DIFFICULTY_DESC: 'הגדרת אבחנה',
    EPILEPSY_1: 'מתי קיבל את ההתקף הראשון?',
    EPILEPSY_2: 'מתי קיבל התקף לאחרונה?',
    EPILEPSY_3: 'איזה תרופות צורך?',
    EPILEPSY_4: 'מתי ביקר לאחרונה אצל ניורולוג?',
    EPILEPSY_5: 'סדר פעולות מומלץ בהתקף',
    EPILEPSY_6: 'גורמים מעוררי התקף',
    EPILEPSY_7: 'תדירות התקפים',
    DIFFICLTY_ARR_L: [
        'תקשורתית',
        'פיזית',
        'קוגניטיבית',
        'חושית',
        'רגשי/התנהגותי',
    ],
    EPILEPSY_7_ARR: [
        'פעם בשנה ויותר',
        'פעם בחצי שנה',
        'פעם בשלושה חודשים',
        'פעם בחודש',
        '5',
        '6',
        '7',
        '8',
        '9',
        '10',
        'שבועי',
        'יומי-מספר התקפים ביום',
    ],
    EPILEPSY_8: 'איך נראה התקף?',
    EPILEPSY_9: 'סימנים מקדימים להתקף',
    EPILEPSY_10: 'תרופת חירום',
    EPILEPSY_11: 'דרך נטילת התרופה',
    EPILEPSY_12: 'טווח זמן עד נטילת התרופה',
    EPILEPSY_LAST_P: '*שימו לב',
    EPILEPSY_LAST_P_2:
        '\'כנפיים של קרמבו\' תפעל על פי הנחיות ההורה באופן מידי בעת ההתקף, אולם אם ההתקף נמשך מעל 5 דקות, או חוזר על עצמו - יוזעק אמבולנס לסניף, זאת בהתאם להוראות חוזר מנכ"ל משרד החינוך, תשס"ב/2(א), י"ד תשרי תשס"ב, 1 באוקטובר 2001.לאור האמור לעיל, אנו מבקשים אישורכם לפעילות בנכם / בתכם כדלקמן :',
    EPILEPSY_LAST_CHECK:
        'הנני מאשר בזאת כי אין מניעה שבני/בתי ישתתף/תשתתף בפעילות בתנועה למרות הופעת התקפי האפילפסיה.ידוע לי כי במידה ויהיה שינוי בתדירות ובעוצמת ההתקפים של בני / ביתי , או ביכולת הצוות בסניף להתמודד, ייתכן ויהיה צורך בנוכחותי או מבוגר מטעם המשפחה בזמן הפעילות.בחתימתי אני גם מאשר את הנחייתי שלעיל להתנהלות בעת התקף אפילפסיה של בני / בתי.        ',
    PARENTS_APPROVAL_H1: 'אישור הורים ',
    PARENTS_APPROVAL1: 'הנני מאשר/ת לבני/בתי להשתתף בפעילות "כנפיים של קרמבו”.',
    PARENTS_APPROVAL1_P_STRONG: 'לידיעתכם,',
    PARENTS_APPROVAL1_P:
        '"כנפיים של קרמבו" מבטחת את פעיליה בביטוח צד ג\', לתשומת ליבכם הביטוח מכסה אך ורק פגיעה הנגרמת במהלך הפעילות בתנועה ועקב פעילות זו.',
    PARENTS_APPROVAL2:
        '  ידוע לי כי אין באפשרות התנועה לספק את התנאים הדרושים על מנת למנוע חשיפה לאלרגנים/ גורמים מעוררי אפילפסיה ולכל גורם נוסף העלול להוביל ליצירת התקף כלשהו.        ',
    PARENTS_APPROVAL3:
        'מחובתי לצייד את בני/בתי בכל הנדרש למתן טיפול רפואי בגין מצב רפואי ידוע.',
    EXPOSURE_H1: 'אישור חשיפה    ',
    EXPOSURE_APPROVAL1_ARR: ['לא מאשר/ת', 'מאשר/ת (השימוש הינו למטרות הבאות):'],
    EXPOSURE_APPROVAL1_ARR_SPECIAL: 'מאשר/ת (השימוש הינו למטרות הבאות):',
    error_msg: 'שדה חובה',
    EXPOSURE_APPROVAL4_ARR: [
        'שימוש פנימי (במסגרת תצוגה בסניף - לוח תמונות, מצגות וסרטונים).',
        'מצגות - הכשרות, סמינרים, גיוסים.',
        "רשתות חברתיות (פייסבוק/אינסטגרם/סנפצ'אט). ",
        'לכל מטרה במסגרת חשיפת הפעילות של התנועה בציבור        ',
        'תוכן שיווקי - קמפיינים פרסומיים של התנועה (ארצי/עירוני). ',
        'תקשורת - ארצית/מקומית - עיתונות כתובה/טלוויזיה.',
    ],
    EXPOSURE_APPROVAL5:
        'ידוע לי כי פרטי בני/בתי מועברים לעיתים לרשות מקומית/משרדי ממשלה/חברות ביטוח לצרכי תמיכה וביטוח.    ',
    RIDE_PERMISSION_H1: 'אישור ליווי נסיעה    ',
    RIDE_P: "כחלק מנגישותה של התנועה, 'כנפיים של קרמבו' מעמידה מערך היסעים לפעילות השבועית וממנה, שמאפשר לפעילים שאינם עצמאיים וזקוקים לתיווך אישי,להשתתף בפעילות באופן קבוע. את מערך ההיסעים מלווים בני נוער עצמאיים בגילאי 16-18 הפעילים בסניף. מערכי ההיסעים והכשרת מלווי ההסעות מוחזקים ומועברים בסניפים בהנחיית מחלקת בטיחות ומפעלים של התנועה.",
    RIDE_PERMISSION_OPTIONS: [
        'הגעה עצמאית ',
        'מגיעים לאסוף אותו',
        '(משתנה (לפעמים כך ולפעמים כך',
    ],
    RIDE_PERMISSION1:
        'ידוע לי כי בני/בתי עשויים לקחת חלק במערך ההיסעים כמלווים של פעילי התנועה הזקוקים להסעה, ליווי הכרוך בנסיעה ברכב ההסעות.',
    RIDE_PERMISSION2:
        'הנני מאשר/ת לבני/בתי להצטרף למערך ההיסעים, אשר הליווי בו מתבצע על ידי בני ובנות נוער הפעילים בסניף.',
    RIDE_OPTIONS: ["א'", "ב'", "ג'", "ד'", "ה'", "ו'", "ז'"],
    NEXT: 'המשך לפרטי הורים',
    ERROR_MSG: 'שדה חובה',
    UPLOAD_TEXT:
        'במצב זה, הנך נדרש להמציא הצהרת רופא בנוגע לאלרגיה/רגישות לנוחיותך, מצ״ב פורמט',
    UPLOAD_DOWNLOAD: 'לחץ כאן להורדה',
    CAN_RELIEVE_HIMSELF: 'האם נזקק לסיוע, תזכורת, ליווי בעת הליכה לשירותים',
    SPECIAL_COMMUNICATION_WAYS: 'לבני/בתי דרכי יצירת תקשורת מיוחדות',
    SPECIAL_COMMUNICATION_WAYS_1: 'דיבור',
    SPECIAL_COMMUNICATION_WAYS_2: 'ג׳סטות',
    SPECIAL_COMMUNICATION_WAYS_3: 'לוח תקשורת',
    SPECIAL_COMMUNICATION_WAYS_4: 'אייפד',
    SPECIAL_COMMUNICATION_WAYS_5: 'מחשב',
    SPECIAL_COMMUNICATION_WAYS_6: 'אחר',
    ATTENTION_REQUIRED_SITUATIONS: 'מצבים הדורשים התייחסות',
    CHALLENGING_BEHAVIOUR_RAGE: 'האם בנך/בתך יש התנהגות מאתגרת או התקפי זעם?',
    WHAT_CALMS_YOUR_CHILD: '  מה מרגיע את בנך/בתך?',
};
exports.PARENTS = {
    YEARS_ARR,
    DAYS_ARR,
    PARENT1_H1: 'הורה 1',
    NAME: 'שם מלא',
    PHONE: 'מספר טלפון',
    COUNTRY: 'ארץ לידה',
    YEAR: 'שנת עליה',
    EMAIL: 'דוא”ל',
    WORK: 'מקום עבודה',
    PARENT2_H1: 'הורה 2 (לא חובה)',
    SIGN: 'חתימה',
    TAKANON:
        '        הנני מתחייב להודיע לרכז הבוגר הסניפי על כל שינוי או הגבלה זמניים / קבועים שיחולו במצב הבריאותי של בני/בתי לרבות קבלת חיסון ו/או החלמה מנגיף הקורונה.',
    SIGN_NAME: 'שם הורה מאשר',
    TAKANON_TEXT: 'תקנון האתר',
    TAKANON_LINK: '',
    WITH_MOUSE: 'צורו חתימה עם העכבר',
    RESET: 'איפוס חתימה',
    NEXT: 'המשך לתשלום',
    FINISH: 'הרשם/י',
    ERROR_MSG: 'שדה חובה',
    ID: 'ת״ז הורה מאשר',
    ERROR_SIGN: 'חתימה חסרה',
    TAKANON2: 'אני מאשר/ת שקראתי את תקנון התנועה',
    TAKANON2_1: ' ',
    TAKANON2_2: ' להלן ומקבל/ת כל התנאים הכתובים בו',
    TAKANON2_2_LINK: '',
    COUNTRIES: countries_1.default.map((m) => m.name),
};
exports.PAYMENT = {
    PAYMENT_H1_1: 'פתיחת שנה',
    REGISTER: 'הרשמה',
    SHIRT: 'חולצה',
    LIST: 'רשימה',
    SHIRT_INVITE: 'הזמנת חולצה',
    TOTAL: 'סה”כ:',
    COUPON: 'קוד קופון:',
    ENTER_COUPON: 'הכנס קוד קופון כאן',
    PAY: 'מעבר לתשלום',
    PAYMENT_H1_2: 'רשימת פריטים לחיוב',
    DISCOUNT: 'הנחה דמי הרשמה:',
    SEND: 'שלח',
    COUPON_ERROR: 'קופון אינו תקין',
    AFTER_DISCOUNT: 'סה״כ אחרי הנחה',
};
exports.workshops = {
    header: 'הרצאות וסדנאות',
    subheader: `"כנפיים של קרמבו"  הינה תנועת נוער רב גונית, בה פעילים ביחד ילדים ונוער עם ובלי מוגבלויות, מכל רבדי החברה הישראלית: חילונים, דתיים, מוסלמים, נוצרים, בדואים, דרוזים, מכל קשת הלקויות ודרגות החומרה.  `,
    mainTextOne: `ב"כנפיים של קרמבו" פותח מודל שילוב והכלה חדשני, המחבר בין ילדים ובני נוער עם צרכים מיוחדים לבין בני נוער מהחינוך הכללי, מכל קצוות החברה. `,
    mainTextTwo: `המודל מאפשר פעילות משותפת, נגישה ומותאמת המביאה לידי ביטוי את היכולות של כל הפעילים. בשל השינוי שפעילות זו מחוללת בחברה הישראלית כלפי אוכלוסיית הצרכים המיוחדים וכלפי אוכלוסיות מודרות בכלל, זכה מודל השילוב הייחודי של התנועה להכרה בין לאומית ע"י האו"ם ו"כנפיים של קרמבו" זכו המעמד של "יועץ מיוחד" בנושא שילוב (יולי 2018). `,
    mainTextThree: `אנו מציעים מגוון של פעילויות, הרצאות וסדנאות, מוכנות מראש או בבנייה והתאמה אישית במגוון נושאים (עולם הצרכים המיוחדים, פעילות משלבת, רוח קרמבו וערכי קרמבו ועוד).`,
    mainTextFour: `באם אתם מעוניינים בהרצאה / סדנה `,
    mainTextFive: `מלאו טופס קצר שנוכל להתאים את ההרצאה או הסדנה לצרכים המדויקים שלכם.`,
    mainTextSix: `אנא הקדישו זמן ומחשבה למילוי הטופס, מלאו את הפרטים בהרחבה והוסיפו בהערות מידע נוסף אם צריך על מנת שנוכל לענות על הצרכים בצורה המיטבית ביותר!`,
    mainTextSeven: `*חוברת ההרצאות והסדנאות מצורפת וניתן לעיין בה.`,
    mainH1: 'טופס לבניית הרצאה/סדנה - כנפיים של קרמבו',
    mainB: 'שלום רב',
    mainP1: '"כנפיים של קרמבו"  הינה תנועת נוער רב גונית, בה פעילים ביחד ילדים ונוער עם ובלי מוגבלויות, מכל רבדי החברה הישראלית: חילונים, דתיים, מוסלמים, נוצרים, בדואים, דרוזים, מכל קשת הלקויות ודרגות החומרה.  ',
    mainP2: `ב"כנפיים של קרמבו" פותח מודל שילוב והכלה חדשני, המחבר בין ילדים ובני נוער עם צרכים מיוחדים לבין בני נוער מהחינוך הכללי, מכל קצוות החברה. המודל מאפשר פעילות משותפת, נגישה ומותאמת המביאה לידי ביטוי את היכולות של כל הפעילים. בשל השינוי שפעילות זו מחוללת בחברה הישראלית כלפי אוכלוסיית הצרכים המיוחדים וכלפי אוכלוסיות מודרות בכלל, זכה מודל השילוב הייחודי של התנועה להכרה בין לאומית ע"י האו"ם ו"כנפיים של קרמבו" זכו המעמד של "יועץ מיוחד" בנושא שילוב (יולי 2018).`,
    mainP3: 'אנו מציעים מגוון של פעילויות, הרצאות וסדנאות, מוכנות מראש או בבנייה והתאמה אישית במגוון נושאים (עולם הצרכים המיוחדים, פעילות משלבת, רוח קרמבו וערכי קרמבו ועוד). נשמח שתמלאו טופס קצר שנוכל להתאים את ההרצאה או הסדנה לצרכים המדויקים שלכם. אנא הקדישו זמן ומחשבה למילוי הטופס, מלאו את הפרטים בהרחבה והוסיפו בהערות מידע נוסף אם צריך על מנת שנוכל לענות על הצרכים בצורה המיטבית ביותר!',
    formH1: 'פרטים ליצירת קשר ומידע על הארגון',
    formH1Span: '(נא למלא את כל הפרטים)',
    formName: 'שם מלא',
    formPhone: 'נייד ליצירת קשר',
    formMail: 'אימייל ליצירת קשר',
    formOrgName: 'שם האירגון הפונה',
    formTextArea: 'נשמח אם תוסיפו כמה מילים על האירגון ופעילותו בכלליות',
    formTextAreaMobile: 'פירוט האירגון ופעילותו הכללית',
    formDate: 'תאריך מבוקש להנחיה*',
    formPlace: 'מקום ההרצאה/ הסדנה/ הביקור:',
    formDisclaimer:
        '*במידה והתאריך אינו ידוע או שמדובר בסדנה של יותר ממפגש אחד השאירו שדה זה ריק',
    sendForm: 'שלח טופס',
    errGeneral: 'שדה חובה',
    errPhone: 'טלפון לא תקין',
    errEmail: 'כתובת מייל לא תקינה',
    headingDetails: 'פרטים על ההרצאה/סדנה/ביקור',
    fillAll: '(נא למלא את כל הפרטים)',
    formFirstRadioHeader: 'מתענינים ב',
    formFirstRadioOption1: 'הרצאה',
    formFirstRadioOption2: 'סדנה (יותר ממפגש אחד)',
    formFirstRadioOption3: 'ביקור מונחה בסניף',
    formFirstRadioElse: 'משהו אחר',
    formGoalsHeader: 'מהי מטרת הפעילות?',
    formGoalsSubHeader:
        'אתגרים שרוצים לפתור, שינוי תפיסה, הרחבת אופקים, שילוב מיטבי, היכרות עם עולם הצרכים המיוחדים ועוד…',
    formDurationHeader: 'פרק זמן המוקצה למפגש',
    intrestedInSubjectsHeader: 'נושאים שיכולים לעניין אותכם',
    intrestedInSubjectsOption1: 'עקרונות ההדרכה המשלבת',
    intrestedInSubjectsOption2: 'תהליכי העצמה',
    intrestedInSubjectsOption3: 'רוח קרמבו וערכי קרמבו',
    intrestedInSubjectsOption4: 'ברוכים הבאים לעולם הצרכים המיוחדים',
    intrestedInSubjectsOption5: 'עיבוד חושי - הקשר לתפקודים יום יומיים',
    howDidYouArrive: 'איך הגעתם אלינו',
    howDidYouArriveOption1: 'דרך האתר',
    howDidYouArriveOption2: 'דרך חברים',
    howDidYouArriveOption3: 'היינו בהרצאה או פעילות משותפת בעבר',
    audienceDetails: 'פרטים על קהל היעד',
    attributesHeader: 'תארו את מאפייני משתתפי הקבוצה',
    attributesDetails: 'מהיכן, גילאים, מוגבליות, תחומי עיסוק, ועוד…',
    practicipatesAmount: 'כמות משתתפים',
    practicipatesRelationsHeader: 'מה היא מידת ההיכרות של הקבוצה',
    practicipatesRelationsDetails:
        'האם הקבוצה נפגשת לראשונה בפעילות, האם הם מכירים ממקום העבודה, נפגשים לעיתים תכופות או עוברים פעילות יחד באופן קבוע',
    practicipatesAdjustmentsHeader: 'האם יש בקהל משתתפים הדורשים התאמות',
    practicipatesAdjustmentsDetails:
        'לקויי ראיה אנשים בעלי נכויות שונות - אם כן - נא לפרט',
    notes: 'הערות נוספות',
};
const managers = [
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/talya.jpg',
        ManageName: 'טליה הראל בז׳רנו',
        Manageposition: 'מנכ"לית',
        ManageEmail: 'talia@krembo.org.il',
        ManagePhone: '',
        test: true,
        ManageHiddenText:
            'שירתה כקצינת חינוך בצה"ל (השתחררה בדרגת סגן). בוגרת ומנחת קבוצות במיכא"ל. בוגרת האוניברסיטה העברית, תואר BA ביחסים בינלאומיים ומדעי המדינה (בהצטיינות) בוגרת תואר שני במנהל עסקים, אוניברסיטת תל אביב. מנכ"ל כנפיים של קרמבו מיוני 2016. ',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'טלי גבריאל כהן',
        Manageposition: 'סמנכ"לית פיתוח עסקי',
        ManageEmail: 'talic@krembo.org.il',
    },
    //   {
    //     ManageImg:
    //       'https://s3.eu-west-1.amazonaws.com/contacts.krembo.org.il/%D7%AA%D7%9E%D7%95%D7%A0%D7%94+%D7%A9%D7%99+%D7%A1%D7%9E%D7%A0%D7%9B%D7%9C+%D7%AA%D7%A4%D7%A2%D7%95%D7%9C.jpeg',
    //     ManageName: 'שי לוי',
    //     Manageposition: 'מנהל תפעול ארצי',
    //     ManageEmail: 'krembo@krembo.org.il',
    //     ManagePhone: '',
    //     ManageHiddenText: '',
    //   },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'איתי זיתון זוהר',
        Manageposition: 'מנהל תפעול ארצי',
        ManageEmail: 'itayz@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText: '',
    },
    // {
    //     ManageImg: 'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/michal.jpeg',
    //     ManageName: 'מיכל ישראל',
    //     Manageposition: 'גיוס משאבים',
    //     ManageEmail: 'michali@krembo.org.il',
    //     ManagePhone: '',
    //     ManageHiddenText: ''
    // },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/סתיו.jpeg',
        ManageName: 'סתיו ויץ',
        Manageposition: 'סמנכ"לית פעילות ארצית',
        ManageEmail: 'stav@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'בוגרת תואר ראשון בלימודי חינוך ומדינת ישראל באוניברסיטת בן גוריון, בעבר מנהלת מרחב דרום בעמותת איילים ומנהלת כפר הסטודנטים באשלים. מנהלת פעילות שטח החל מינואר 2015',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/eldad.jpeg',
        ManageName: 'אלדד אופיר',
        Manageposition: 'סמנכ"ל כספים',
        ManageEmail: 'eldad@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'שירת בחיל הקשר. ניסיון רב בניהול כספים בארגונים מסחריים וקמעוניים. רואה חשבון החל משנת 2013.  בעל תואר B.A במינהל עסקים, התמחות בחשבונאות המכללה האקדמית קרית אונו. בוגר קורס כלכלן פרקטי . מנהל כספים החל מינואר 2019.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/טל.jpg',
        ManageName: 'טל בן אריה מנשס',
        Manageposition: 'סמנכ"לית משאבי אנוש',
        ManageEmail: 'hr@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText:
            'בעלת למעלה מ 13 שנות ניסיון במשאבי אנוש במגזר העסקי. כיהנה כסמנכ"ל משאבי אנוש בחברות : Viber, ePlane  ו - iMesh,, בעלת תואר שני בתרבות ומגדר מאוניברסיטת אמסטרדם ותואר ראשון בתקשורת ומדעי המדינה, מאוניברסיטת תל-אביב. מנהלת משאבי אנוש החל ',
    },
    //   {
    //     ManageImg:
    //       'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/nurit.jpg',
    //     ManageName: 'נורית בן אשר גולן',
    //     Manageposition: 'סמנכ"לית מקצועית',
    //     ManageEmail: 'nurit@krembo.org.il',
    //     ManagePhone: '',
    //     ManageHiddenText:
    //       'שירתה כקצינת חינוך בצה"ל (השתחררה בדרגת סגן). בוגרת המכללה האקדמית תל חי. תואר BA בחינוך מיוחד ופסיכולוגיה. בוגרת תעודת הוראה בחינוך מיוחד, אוניברסיטת תל אביב. מנהלת מחלקה מקצועית- מרץ 2015 ',
    //   },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'שרון ארבר',
        Manageposition: 'יועצת משפטית',
        ManageEmail: 'krembo_law@krembo.org.il',
        ManagePhone: '',
        ManageHiddenText: '',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'אלה מעוז בן זאב',
        Manageposition: 'סמנכ״לית אגף חינוך',
        ManageEmail: 'ella@krembo.org.il',
        // ManagePhone: '052-2547538',
        ManageHiddenText:
            'שמשה במהלך עשר שנים כבעלים משותף ומנהלת יחסי הציבור וקשרי הלקוחות של קבוצת מיתוס (חברת שיווק והפקות אירועים שיווקיים מהמובילות בישראל).בעברה שימשה בתפקידי יחסי ציבור ודוברות בארגונים ומשרדים מובילים כארד תקשורת, שיאון תקשורת ופרסום שירה שקולניק.בעלת תואר ראשון ולימודי תקשורת מאוניברסיטת תל אביב, מנהלת את תחום יחסי הציבור בכנפיים של קרמבו החל מינואר 2014.',
    },
    //   {
    //     ManageImg:
    //       'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
    //     ManageName: 'יניר לוין',
    //     Manageposition: 'מנהל בטיחות וביטחון, ממונה קורונה ורכז נגישות',
    //     ManageEmail: 'Ianir@krembo.org.il',
    //     ManagePhone: '052-2547538',
    //   },
    //   {
    //     ManageImg:
    //       'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
    //     ManageName: 'שרית מרקו',
    //     Manageposition: 'כמנהלת רכש',
    //     ManageEmail: 'sarit@krembo.org.il',
    //   },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'עדי אליהו',
        Manageposition: 'עוזרת מנכ״ל',
        ManageEmail: 'adieliyahu@krembo.org.il',
    },
    {
        ManageImg:
            'https://s3.eu-west-1.amazonaws.com/contacts.krembo.org.il/%D7%A2%D7%99%D7%93%D7%95.jpg',
        ManageName: 'עידו ברנע',
        Manageposition: 'סמנכ״ל הגשמה',
        ManageEmail: 'ido@krembo.org.il',
    },

    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'נטלי אביאלי',
        Manageposition: 'מנהלת שיווק',
        ManageEmail: 'nataliea@krembo.org.il',
    },
    //   {
    //     ManageImg:
    //       'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
    //     ManageName: 'סיגל דקל',
    //     Manageposition: 'יחסי ציבור ועיתונות',
    //     ManageEmail: 'sigald@krembo.org.il',
    //   },
];
const managers_branches = [
    {
        name: 'דוד קאופמן',
        position: 'מנהל תפעול ובטיחות',
        phone: '052-7977850 ',
        email: 'david@krembo.org.il',
    },
    {
        name: '	הדס שטנגר',
        position: 'מנהלת מחלקת הדרכה',
        phone: '054-2175735 ',
        email: 'Hadass@krembo.org.il',
    },
    {
        name: '	סתיו ויץ	',
        position: 'מנהלת מחלקת פיתוח ופעילות ארצית',
        phone: ' 054-2542692 ',
        email: 'stav@krembo.org.il',
    },
    {
        name: 'עדי אליהו',
        position: 'מנהלת תחום שנת שירות והגשמה',
        phone: '	050-6392984 ',
        email: 'adieliyahu@krembo.org.il',
    },
    {
        name: '	עדי אלאלוף',
        position: 'מנהלת פעילות ארצית',
        phone: '052-3418444 ',
        email: 'adia@krembo.org.il',
    },
    {
        name: ' 	אייל גולדמן',
        position: ' 	מנהל מחוז צפון',
        phone: '054-5921252  ',
        email: 'eyalg@krembo.org.il',
    },
    {
        name: 'נוי כוכבה',
        position: 'רכזת שילוב מחוז צפון',
        phone: '052-3226333 ',
        email: 'noykochva@krembo.org.il',
    },
    {
        name: 'עתליה שפר	',
        position: '	מנהלת מחוז שרון',
        phone: '052-8991404',
        email: 'atalya@krembo.org.il',
    },
    {
        name: 'עדי אלוני	',
        position: '	רכזת שילוב מחוז שרון',
        phone: '052-6454225',
        email: 'adi.aloni@krembo.org.il',
    },
    {
        name: 'עידו ברנע',
        position: 'מנהל מחוז מרכז	',
        phone: '054-5400617    ',
        email: 'ido@krembo.org.il   ',
    },
    {
        name: 'אור וינרייך',
        position: 'רכזת שילוב מחוז מרכז',
        phone: '050-2440460',
        email: 'or@krembo.org.il',
    },
    {
        name: 'חוליאן קרסנבלט',
        position: 'רכז עירוני תל אביב- יפו',
        phone: '050-7420989',
        email: 'julian.krembo@gmail.com',
    },
    {
        name: 'שקד בן משה',
        position: 'רכזת שילוב מחוז שפלה',
        phone: '052-5672952 ',
        email: 'shaked@krembo.org.il',
    },
    {
        name: 'לינה נבואני	',
        position: '	מנהל מחוז החברה הערבית',
        phone: '054-6738874 ',
        email: 'lina@krembo.org.il',
    },
    {
        name: '	מג´דולין אבו חוף',
        position: 'רכזת שילוב מחוז החברה הערבית',
        phone: '050-3068330',
        email: 'majdoleen@krembo.org.il',
    },
    {
        name: 'שרה פארן',
        position: 'רכזת שילוב מחוז דרום',
        phone: '058-6518562 ',
        email: 'saraf@krembo.org.il',
    },
    {
        name: 'רועי סבן ',
        position: 'מנהל רכש',
        phone: '0542378020 ',
        email: 'roei@krembo.org.il',
    },
];
const managers_vaad = [
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Nir Bronstein.jpg',
        ManageName: 'ניר ברונשטיין',
        Manageposition: 'יו"ר  הדירקטוריון',
        ManageHiddenText:
            'ניר מעורב למעלה מעשור בפעילות ענפה בתחום התרומה לקהילה, תוך דגש על פעילות של ילדים עם צרכים מיוחדים.ניר הוא דירקטור במספר חברות ציבוריות ופרטיות בארץ ובחו"ל ופעיל בתחום המיזוגים והרכישות וליווי חברות בתהליכים אסטרטגיים הנפקות וגיוסי הון.לפני כן שירת ניר כמנכ"ל פועלים שוקי הון וכיו"ר חברת הבת שלה פועלים סקיוריטיס שבארה"ב, לפני כן שרת כנשיא ומנכ"ל בחברת תמיר פישמן ניהול השקעות.  ניר הינו בוגר תוכנית המנהלים של לונדון ביזנס סקול.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Hain Shane.JPG',
        ManageName: 'חן שיין ',
        Manageposition: 'דירקטוריון ויו"ר ועדת כספים',
        ManageHiddenText:
            'חן שיין, רואה חשבון , שותף בכיר בפירמת ארנסט & יאנג ישראל ( קוסט , פורר , גבאי את קסירר ) משנת 1991 . חבר הועדה המנהלת של הפירמה ואחראי על תחום הנדל"ן ומלכרים. בעל ניסיון רב בטיפול במלכרים לרבות אוניברסיטת ת"א , מכון ויצמן , פרח, התזמורת הפילהרמונית , ועוד. בעל תואר ראשון בכלכלה וחשבונאות ותואר שני במימון מאוניברסיטת ת"א.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Klaodia Kobi.jpg',
        ManageName: 'קלאודיה קובי',
        Manageposition: 'אמא מייסדת וחברת דירקטוריון',
        ManageHiddenText:
            'החל משנת 1996 ועד היום בעלת החברה לעיצוב ומיתוג   True Design אמא של כפיר קובי, החניך הראשון וההשראה לתנועה. יו"ר ועדת ההיגוי ואחראית מטעם הועד המנהל על תחום הצרכים המיוחדים בתנועה ומפתחת שיטת חונך כמתווך,בוגרת המחלקה לתקשורת חזותית, בעלת תואר ,B.Des "בצלאל האקדמיה לאמנות ועיצוב ירושלים" ',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/User photo icon.svg',
        ManageName: 'אבי ניסן',
        Manageposition: 'חבר דירקטוריון',
        ManageHiddenText:
            'רואה חשבון המחזיק תואר ראשון במנהל עסקים. אבי הינו הבעלים של משרד לראיית חשבון "אבי ניסן - רו"ח". נשוי עם שלושה ילדים ומתגורר בתל אביב.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/tal.600.jpg',
        ManageName: 'טל אייזנר ',
        Manageposition: 'חבר דירקטוריון ',
        ManageHiddenText:
            'פעיל מזה מספר שנים בתחום ילדים עם צרכים מיוחדים. הצטרף לוועד המנהל של "כנפיים של קרמבו" בשנת 2008. שימש במספר תפקידים  בחברות הייטק בתחום מניעת הונאות וסייבר. כיום עובד בחברת צ´ק פוינט.  חבר אסיפה כללית "בית איזי שפירא", בוגר אוניברסיטת תל אביב.  נשוי פלוס 6.  ',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Ika Abarbanel.jpg',
        ManageName: 'איקה אברבנל',
        Manageposition: 'חבר דירקטוריון',
        ManageHiddenText:
            'מומחה בתחום ניהול אינטגרציה. לשעבר חבר הנהלת "טבע", מנהל אינטגרציה הראשי וסמנכ"ל בכיר למשאבי אנוש ויו"ר משותף ל JV-PGT בין "טבע" לחברת "פרוקטר אנד גמבל". כיהן כמשנה למנכ"ל "בזק" וכסמנכ"ל בכיר לתפעול ושרות לקוחות ב"פלאפון". שרת בצה"ל במשך 25 שנה ופרש בדרגת תת – אלוף. בעל תואר ראשון ושני במדעי המדינה ובוגר המכללה לביטחון לאומי. פעיל בתחום הפילנטרופי כמייסד ויו"ר "אמץ לוחם", נשיא Prize4Life וחבר וועד מנהל ב"בצלאל".',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Nurit berman.jpg',
        ManageName: 'נורית ברמן',
        Manageposition: 'חברת דירקטוריון',
        ManageHiddenText:
            'מנהלת את קבוצת עמדה שעוסקת באסטרטגיות של משאבי אנוש. בהכשרתה המקצועית נורית ברמן הינה עובדת סוציאלית.',
    },
    {
        ManageImg:
            'https://krembowebsiteimages.s3-eu-west-1.amazonaws.com/Tamir Dagan.jpg',
        ManageName: ' תמיר דגן',
        Manageposition: 'חבר דירקטוריון',
        ManageHiddenText:
            'בעל תואר ראשון בכלכלה וסטטיסטיקה (BA), האוניברסיטה העברית, ירושלים ובעל תואר שני במנהל עסקים (MA), אוניברסיטת בן-גוריון, באר שבע.',
    },
];
exports.default = {
    LANGUAGE: exports.LANGUAGE,
    navbar: exports.navbar,
    mainpage: exports.mainpage,
    press: exports.press,
    reports: exports.reports,
    thanks: exports.thanks,
    event: exports.event,
    donate: exports.donate,
    branches: exports.branches,
    about: exports.about,
    signup: exports.signup,
    footer: exports.footer,
    contact: exports.contact,
    educational: exports.educational,
    activity: exports.activity,
    vision: exports.vision,
    symbol: exports.symbol,
    register: exports.register,
    REGISTER_SUCCESS: exports.REGISTER_SUCCESS,
    TUTOR: exports.TUTOR,
    PERSONAL: exports.PERSONAL,
    PERMISSIONS: exports.PERMISSIONS,
    PARENTS: exports.PARENTS,
    PAYMENT: exports.PAYMENT,
    workshops: exports.workshops,
    managers,
    managers_branches,
    managers_vaad,
    all_branches: branch_parser_1.branchprices,
};
//# sourceMappingURL=content_hebrew.js.map
